var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadSectionImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 370,
    viewBox: "0 0 507 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_19332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.276 190.006L303.377 261.859V126.742L180.276 54.8405V190.006Z",
    fill: "#F04422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.151 186.031L296.551 249.932V130.669L187.151 66.7668V186.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.151 186.08L285.209 124.043L187.151 66.7668V186.08Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 174.448C224.464 174.442 226.616 174.623 228.74 174.988H240.329V179.454C239.936 183.233 232.669 187.503 222.308 187.503C211.947 187.503 204.582 183.331 204.287 179.552V175.086H215.876C217.997 174.689 220.15 174.476 222.308 174.448Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 182.595C237.868 182.943 237.471 183.24 237.039 183.479V174.988H238.217V182.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 174.84V187.012H215.679V174.988L216.858 174.84Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 187.209H217.643V174.742H218.773V187.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 184.656L207.921 184.018V174.988H209.05V184.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 187.503H219.558V174.742H220.737V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 183.479C206.713 183.207 206.318 182.895 205.957 182.546V174.988H207.135V183.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 186.129L211.8 185.785V174.988H212.929V186.129Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 186.62H213.764V174.988H214.894V186.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 185.491L209.885 185.049V175.233H211.015V185.491Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 185.883L231.245 186.227V174.988H232.374V185.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 187.503H223.487V174.448H224.616V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 174.448V187.503H221.522V174.448H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 179.454C240.162 180.416 239.73 181.313 239.052 182.006V174.988H240.329L240.28 179.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 181.663C204.658 181.029 204.335 180.263 204.238 179.454V174.988H205.22L205.171 181.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 184.215L235.124 184.804V174.988H236.253V184.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 187.16H225.402V174.595H226.531V187.16Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 185.147L233.16 185.638V174.988H234.338V185.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 186.423L229.281 186.718V174.988H230.41V186.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 186.865H227.366V174.791H228.495V186.865Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 166.448C232.914 166.448 240.329 170.767 240.329 174.644C240.329 178.522 232.865 182.841 222.308 182.841C211.751 182.841 204.238 178.522 204.238 174.644C204.238 170.767 211.604 166.448 222.308 166.448Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 180.779C232.728 181.268 231.433 181.678 230.115 182.006L215.385 167.282C216.858 166.977 218.351 166.78 219.853 166.693L233.995 180.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 182.841H220.786L207.872 169.883C208.467 169.507 209.091 169.179 209.738 168.902L223.683 182.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 182.104H228.937L230.803 181.564L232.62 180.975L233.503 180.632H233.945H234.387L236.106 179.798C237.236 179.181 238.305 178.458 239.298 177.638C238.57 178.769 237.617 179.737 236.499 180.485L235.664 181.025L234.78 181.466L234.338 181.712H233.896L232.963 182.104L232.03 182.399H231.048C230.404 182.577 229.748 182.708 229.084 182.791C228.446 182.791 227.758 182.791 227.12 182.791H225.107L227.218 182.595L228.004 182.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 182.202H221.621H222.946H224.272L222.946 182.497H222.308H221.621C220.722 182.57 219.819 182.57 218.92 182.497C218.024 182.405 217.138 182.241 216.268 182.006C215.403 181.808 214.563 181.511 213.764 181.123C214.647 181.074 215.533 181.074 216.416 181.123L219.018 182.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 165.663C224.464 165.657 226.616 165.838 228.741 166.202H240.329V170.62C240.034 174.448 232.767 178.62 222.357 178.62C211.947 178.62 204.631 174.448 204.337 170.62V166.202H215.925C218.033 165.841 220.169 165.661 222.308 165.663Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 174.055C237.854 174.372 237.459 174.652 237.039 174.89V166.202H238.217V174.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 166.055V178.227H215.679V166.202L216.858 166.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 178.423H217.643V165.957H218.773V178.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 175.871L207.921 175.233V166.202H209.05V175.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 178.571H219.558V165.81H220.737V178.571Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 174.693C206.713 174.422 206.318 174.11 205.957 173.761V166.202H207.135V174.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 177.344L211.8 177V166.202H212.929V177.344Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 177.687H213.764V166.202H214.894V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 176.706L209.885 176.264V166.202H211.015V176.706Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 177.098L231.245 177.442V166.202H232.374V177.098Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 178.521H223.487V165.663H224.616V178.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 165.663V178.62H221.522V165.663H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 170.62C240.172 171.599 239.74 172.515 239.052 173.221V166.202H240.329L240.28 170.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 172.779C204.647 172.133 204.323 171.349 204.238 170.521V166.104H205.22L205.171 172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 175.429L235.124 176.018V166.202H236.253V175.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 178.325H225.402V165.81H226.531V178.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 176.362L233.16 176.853V166.202H234.338V176.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 177.687L229.281 177.982V166.202H230.41V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 178.08H227.366V166.006H228.495V178.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 157.663C232.914 157.663 240.329 161.982 240.329 165.859C240.329 169.736 232.865 174.055 222.308 174.055C211.751 174.055 204.238 169.736 204.238 165.859C204.238 161.982 211.604 157.663 222.308 157.663Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 171.994C232.728 172.482 231.433 172.892 230.115 173.221L215.385 158.497C216.858 158.192 218.351 157.995 219.853 157.908L233.995 171.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 174.055H220.786L207.872 161.098C208.467 160.722 209.091 160.394 209.738 160.117L223.683 174.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 173.319H228.937L230.803 172.779L232.62 172.19L233.503 171.847H233.945H234.387L236.106 171.012C237.236 170.396 238.305 169.673 239.298 168.853C238.586 169.983 237.629 170.939 236.499 171.65C236.242 171.875 235.962 172.073 235.664 172.239L234.78 172.73H234.338H233.896L232.963 173.123L232.129 173.27H231.146C230.502 173.448 229.846 173.579 229.182 173.663C228.544 173.663 227.857 173.663 227.218 173.663H225.205L227.12 173.27L228.004 173.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 173.417H221.621H222.946H224.272L222.946 173.712H222.308H221.621C220.722 173.785 219.819 173.785 218.92 173.712C218.024 173.62 217.138 173.455 216.268 173.221C215.395 173.026 214.552 172.712 213.764 172.288H216.416L219.018 173.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 156.877C224.464 156.872 226.616 157.052 228.741 157.417H240.329V161.834C240.034 165.663 232.767 169.834 222.357 169.834C211.947 169.834 204.631 165.663 204.337 161.834V157.417H215.925C218.033 157.056 220.169 156.876 222.308 156.877Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 165.221C237.855 165.554 237.46 165.85 237.039 166.104V157.417H238.217V165.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 157.27V169.442H215.679V157.417L216.858 157.27Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 169.638H217.643V157.172H218.773V169.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 167.086L207.921 166.448V157.417H209.05V167.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 169.785H219.558V157.025H220.737V169.785Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 165.908C206.713 165.637 206.318 165.324 205.957 164.975V157.417H207.135V165.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 168.558L211.8 168.215V157.417H212.929V168.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 169.049L213.764 168.804V157.417H214.894V169.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 167.871L209.885 167.429V157.417H211.015V167.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 168.313L231.245 168.656V157.417H232.374V168.313Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 169.736H223.487V156.877H224.616V169.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 156.877V169.785H221.522V156.877H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 161.834C240.172 162.814 239.74 163.73 239.052 164.436V157.417H240.329L240.28 161.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 164.092C204.647 163.446 204.323 162.662 204.238 161.834V157.417H205.22L205.171 164.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 166.595C235.894 166.837 235.516 167.05 235.124 167.233V157.417H236.253V166.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 169.589H225.402V157.025H226.531V169.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 167.577L233.16 168.067V157.417H234.338V167.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 168.853L229.281 169.147V157.417H230.41V168.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 169.294H227.366V157.221H228.495V169.294Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 148.877C232.914 148.877 240.329 153.196 240.329 157.074C240.329 160.951 232.865 165.27 222.308 165.27C211.751 165.27 204.238 160.951 204.238 157.074C204.238 153.196 211.604 148.877 222.308 148.877Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 163.209C232.734 163.702 231.437 164.096 230.115 164.386L215.385 149.663C216.858 149.357 218.351 149.16 219.853 149.074L233.995 163.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 165.221H220.786L207.872 152.313C208.467 151.937 209.091 151.608 209.738 151.331L223.683 165.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 164.534H228.937L230.803 163.994L232.62 163.405L233.503 163.061H233.945H234.387L236.106 162.227C237.236 161.61 238.305 160.887 239.298 160.068C238.57 161.198 237.617 162.167 236.499 162.914L235.664 163.454L234.78 163.896L234.338 164.141H233.896L232.963 164.534L232.03 164.828H231.048C230.404 165.006 229.748 165.137 229.084 165.221C228.446 165.221 227.758 165.221 227.12 165.221H225.107C225.735 165.043 226.375 164.912 227.022 164.828L228.004 164.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 164.632H221.621H222.946H224.272L222.946 164.926H222.308H221.621C219.822 165.026 218.019 164.861 216.268 164.436C215.395 164.24 214.552 163.926 213.764 163.503H216.416L219.018 164.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 149.564C224.464 149.559 226.616 149.739 228.741 150.104H240.329V154.521C240.034 158.35 232.767 162.472 222.357 162.472C211.947 162.472 204.631 158.35 204.337 154.521V150.104H215.925C218.033 149.743 220.169 149.563 222.308 149.564Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 158.055L237.039 158.939V150.104H238.217V158.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 149.957V162.08H215.679V150.104L216.858 149.957Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 162.325H217.643V149.81H218.773V162.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 159.773L207.921 159.135V150.104H209.05V159.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 162.472H219.558V149.663H220.737V162.472Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 158.595C206.713 158.324 206.318 158.011 205.957 157.663V150.104H207.135V158.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 161.245L211.8 160.902V150.104H212.929V161.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 161.736H213.764V150.104H214.894V161.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 160.607L209.885 160.166V150.104H211.015V160.607Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 161L231.245 161.344V150.104H232.374V161Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 162.423H223.487V149.564H224.616V162.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 149.564V162.472H221.522V149.564H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 154.521C240.172 155.501 239.74 156.417 239.052 157.123V150.104H240.329L240.28 154.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 156.779C204.647 156.133 204.323 155.349 204.238 154.521V150.104H205.22L205.171 156.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 159.282L235.124 159.92V150.104H236.253V159.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 162.227H225.402V149.663H226.531V162.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 160.264L233.16 160.705V150.104H234.338V160.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 161.54H229.281V150.104H230.41V161.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 161.982H227.366V149.908H228.495V161.982Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 141.564C232.914 141.564 240.329 145.883 240.329 149.761C240.329 153.638 232.865 158.055 222.308 158.055C211.751 158.055 204.238 153.736 204.238 149.859C204.238 145.982 211.604 141.564 222.308 141.564Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 155.896C232.734 156.389 231.437 156.783 230.115 157.074L215.385 142.35C216.858 142.044 218.351 141.848 219.853 141.761L233.995 155.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 158.055H220.786L207.872 145.147L209.738 144.117L223.683 158.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 157.221H228.937L230.803 156.73L232.62 156.141L233.503 155.798H233.945H234.387C234.979 155.559 235.553 155.281 236.106 154.963C237.245 154.381 238.316 153.673 239.298 152.853C238.586 153.983 237.629 154.939 236.499 155.65L235.664 156.19L234.78 156.681L234.338 156.926H233.896L232.963 157.319L232.03 157.614L231.048 157.859C230.403 158.021 229.746 158.136 229.084 158.202L227.218 158.055H225.205L227.12 157.614L228.004 157.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 157.319H221.621H222.946H224.272L222.946 157.613H222.308H221.621C219.822 157.713 218.019 157.548 216.268 157.123C215.401 156.907 214.561 156.594 213.764 156.19C214.648 156.19 215.532 156.19 216.416 156.19L219.018 157.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 140.779C224.464 140.774 226.616 140.954 228.741 141.319H240.329V145.736C240.034 149.564 232.767 153.687 222.357 153.687C211.947 153.687 204.631 149.564 204.337 145.736V141.319H215.925C218.033 140.958 220.169 140.777 222.308 140.779Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 149.123L237.039 150.006V141.319H238.217V149.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 141.172V153.147H215.679V141.368L216.858 141.172Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 153.54H217.643V141.025H218.773V153.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 150.988L207.921 150.35V141.319H209.05V150.988Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 153.687H219.558V140.877H220.737V153.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 149.81C206.713 149.539 206.318 149.226 205.957 148.877V141.319H207.135V149.81Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 152.46L211.8 152.117V141.319H212.929V152.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 153.147L213.764 152.902V141.319H214.894V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 151.822L209.885 151.331V141.515H211.015V151.822Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 152.215L231.245 152.558V141.319H232.374V152.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 153.638H223.487V140.779H224.616V153.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 140.779V153.687H221.522V140.779H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 145.736C240.172 146.716 239.74 147.632 239.052 148.337V141.319H240.329L240.28 145.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 148.239C204.656 147.588 204.333 146.806 204.238 145.982V141.564H205.22L205.171 148.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 150.497C235.894 150.738 235.516 150.952 235.124 151.135V141.319H236.253V150.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 153.442H225.402V140.877H226.531V153.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 151.479L233.16 151.92V141.319H234.338V151.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 152.755H229.281V141.319H230.41V152.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 153.147H227.218V141.123H228.348L228.495 153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 132.779C232.914 132.779 240.329 137.098 240.329 140.975C240.329 144.853 232.865 149.172 222.308 149.172C211.751 149.172 204.238 144.853 204.238 140.975C204.238 137.098 211.604 132.779 222.308 132.779Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 147.11C232.734 147.604 231.437 147.998 230.115 148.288L215.385 133.564C216.858 133.259 218.351 133.062 219.853 132.975L233.995 147.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 149.123H220.786L207.872 136.215L209.738 135.184L223.683 149.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 148.239L228.937 147.994L230.803 147.503L232.62 146.914L233.503 146.571H233.945H234.387L236.106 145.785C237.236 145.169 238.305 144.445 239.298 143.626C238.586 144.756 237.629 145.712 236.499 146.423L235.664 146.963L234.78 147.454L234.338 147.699H233.896L232.963 148.043L232.129 148.239H231.146C230.501 148.401 229.845 148.516 229.182 148.583H227.218H225.205C225.843 148.583 226.482 148.288 227.12 148.141L228.004 148.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 148.534L221.621 148.779H222.946L224.272 149.025L222.946 149.319H222.308H221.621C220.723 149.417 219.817 149.417 218.92 149.319C218.026 149.244 217.139 149.096 216.268 148.877C215.401 148.662 214.561 148.349 213.764 147.945C214.648 147.945 215.532 147.945 216.416 147.945L219.018 148.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 131.994C224.464 131.988 226.616 132.169 228.741 132.534H240.329V136.951C240.034 140.779 232.767 144.902 222.357 144.902C211.947 144.902 204.631 140.779 204.337 136.951V132.534H215.925C218.033 132.173 220.169 131.992 222.308 131.994Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.217 140.337L237.039 141.221V132.534H238.217V140.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.858 132.386V144.509H215.679V132.534L216.858 132.386Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.773 144.755H217.643V132.239H218.773V144.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 142.202L207.921 141.564V132.534H209.05V142.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.737 144.902H219.558V132.092H220.737V144.902Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.135 141.025C206.724 140.738 206.33 140.427 205.957 140.092V132.534H207.135V141.025Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.929 143.675L211.8 143.331V132.534H212.929V143.675Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.894 144.166L213.764 143.92V132.534H214.894V144.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.015 143.037L209.885 142.546V132.73H211.015V143.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.374 143.331L231.245 143.675V132.534H232.374V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.616 144.853H223.487V131.994H224.616V144.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.652 131.994V144.902H221.522V131.994H222.652Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 136.951C240.172 137.931 239.74 138.846 239.052 139.552V132.534H240.329L240.28 136.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.171 139.209C204.656 138.557 204.333 137.776 204.238 136.951V132.534H205.22L205.171 139.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.253 141.712L235.124 142.35V132.534H236.253V141.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.531 144.656H225.402V132.092H226.531V144.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.338 142.693L233.16 143.135V132.534H234.338V142.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 143.969L229.281 144.215V132.534H230.41V143.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.495 144.362H227.366V132.337H228.495V144.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 123.994C232.914 123.994 240.329 128.313 240.329 132.19C240.329 136.067 232.865 140.386 222.308 140.386C211.751 140.386 204.238 136.067 204.238 132.19C204.238 128.313 211.604 123.994 222.308 123.994Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M233.995 138.423C232.734 138.917 231.437 139.311 230.115 139.601L215.385 124.877C216.858 124.572 218.351 124.375 219.853 124.288L233.995 138.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M223.683 140.337H220.786L207.872 127.429L209.738 126.399L223.683 140.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M228.004 139.65L228.937 139.405L230.803 138.914L232.62 138.423L233.503 138.08H233.945H234.387L236.106 137.245C237.245 136.663 238.316 135.955 239.298 135.135C238.586 136.265 237.629 137.221 236.499 137.932L235.664 138.472L234.78 138.963H234.338H233.896L232.963 139.307L232.03 139.65L231.048 139.896C230.403 140.058 229.746 140.173 229.084 140.239C228.43 140.288 227.774 140.288 227.12 140.239H225.107L227.022 139.798L228.004 139.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M219.018 139.748L221.621 139.994H222.946L224.272 140.239L222.946 140.534H222.308H221.621C220.723 140.632 219.817 140.632 218.92 140.534C218.026 140.458 217.139 140.311 216.268 140.092C215.401 139.876 214.561 139.563 213.764 139.159H216.416L219.018 139.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 158.055C274.797 158.04 276.951 158.238 279.071 158.644H290.659V162.963C290.364 166.742 283.048 170.914 272.638 170.914C262.229 170.914 254.912 166.742 254.618 162.963V158.546H266.206C268.329 158.173 270.483 158.008 272.638 158.055Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 166.202C288.25 166.519 287.872 166.799 287.467 167.037V158.399H288.597V166.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 158.055V170.227H266.108V158.448L267.237 158.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 170.62H268.023V158.055H269.201V170.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 167.871L258.3 167.233V158.399H259.479V167.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 170.718H269.987V158.055H271.116V170.718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 166.84C257.117 166.557 256.739 166.245 256.385 165.908V158.399H257.515V166.84Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 169.54L262.229 169.147V158.399H263.358V169.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 170.031L264.144 169.736V158.399H265.273V170.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 168.902L260.461 168.411V158.595H261.59V168.902Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 169.245L281.624 169.589V158.399H282.803V169.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 170.669H273.866V158.055H274.995V170.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 158.055V171.012H271.902V158.055H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 162.963C290.519 163.933 290.091 164.839 289.431 165.564V158.399H290.659V162.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 165.025C255.054 164.406 254.711 163.635 254.618 162.816V158.399H255.6V165.025Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 167.577L285.503 168.166V158.35H286.682V167.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 170.521H275.83V158.055H276.959V170.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 168.509L283.588 169V158.399H284.718V168.509Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 169.834L279.709 170.08V158.399H280.838V169.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 170.227H277.745V158.055H278.874V170.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 149.859C283.245 149.859 290.659 154.178 290.659 158.055C290.659 161.933 283.245 166.202 272.638 166.202C262.032 166.202 254.618 161.883 254.618 158.055C254.618 154.227 262.032 149.859 272.638 149.859Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 164.141C283.132 164.652 281.851 165.062 280.544 165.368L265.813 150.644C267.237 150.399 268.71 150.202 270.331 150.055L284.374 164.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 166.202H271.411L258.251 153.147C258.869 152.781 259.508 152.453 260.166 152.166L274.111 166.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 165.466H279.316C279.955 165.466 280.593 165.172 281.182 164.926C281.803 164.782 282.411 164.585 282.999 164.337L283.883 163.994H284.325H284.767L286.485 163.16C287.642 162.561 288.728 161.837 289.726 161C288.998 162.13 288.045 163.099 286.927 163.847L286.092 164.387L285.209 164.877H284.767H284.276L283.343 165.27L282.41 165.564C282.084 165.615 281.753 165.615 281.428 165.564C280.784 165.747 280.128 165.878 279.464 165.957C278.825 165.957 278.138 165.957 277.5 165.957H275.535L277.45 165.564L278.383 165.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 165.564H272H273.326H274.652L273.375 165.859H272.687H272C271.118 165.932 270.231 165.932 269.348 165.859C268.451 165.777 267.564 165.612 266.697 165.368C265.816 165.17 264.959 164.873 264.144 164.485H266.795L269.447 165.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 149.025C274.797 149.01 276.951 149.207 279.071 149.613H290.659V154.031C290.364 157.81 283.048 161.982 272.638 161.982C262.229 161.982 254.912 157.81 254.618 154.031V149.613H266.206C268.326 149.207 270.48 149.01 272.638 149.025Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 157.417C288.25 157.734 287.872 158.014 287.467 158.252V149.614H288.597V157.417Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 149.417V161.589H266.108V149.81L267.237 149.417Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 161.834H268.023V149.319H269.201V161.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 159.233L258.3 158.595V149.614H259.479V159.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 161.932H269.987V149.172H271.116V161.932Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 158.055C257.117 157.771 256.739 157.46 256.385 157.123V149.614H257.515V158.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 160.755L262.229 160.362V149.614H263.358V160.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 161.245L264.144 160.951V149.614H265.273V161.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 160.067L260.461 159.626V149.81H261.59V160.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 160.46L281.624 160.804V149.614H282.803V160.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 161.883H273.866V149.025H274.995V161.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 149.025V161.982H271.902V149.025H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 154.031C290.519 155.001 290.091 155.907 289.431 156.632V149.614H290.659V154.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 156.239C255.054 155.621 254.711 154.85 254.618 154.031V149.614H255.6V156.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 158.791L285.503 159.38V149.564H286.682V158.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 161.736H275.83V149.172H276.959V161.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 159.724L283.588 160.215V149.614H284.718V159.724Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 161.049H279.709V149.614H280.838V161.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 161.442H277.745V149.172H278.874V161.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 141.074C283.245 141.074 290.659 145.393 290.659 149.27C290.659 153.147 283.245 157.417 272.638 157.417C262.032 157.417 254.618 153.098 254.618 149.27C254.618 145.442 262.032 141.074 272.638 141.074Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 155.356C283.132 155.867 281.851 156.277 280.544 156.583L265.813 141.859C267.307 141.578 268.815 141.381 270.331 141.27L284.374 155.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 157.417H271.411L258.448 144.46C259.065 144.094 259.705 143.766 260.363 143.479L274.111 157.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 156.681H279.316C279.955 156.681 280.593 156.387 281.182 156.141C281.771 155.896 282.41 155.748 282.999 155.552L283.883 155.209H284.325H284.767L286.485 154.374C287.642 153.776 288.728 153.051 289.726 152.215C288.998 153.345 288.045 154.314 286.927 155.061L286.092 155.601L285.209 156.092H284.767H284.276L283.343 156.485L282.41 156.779L281.428 157.074L279.464 157.417C278.825 157.417 278.138 157.417 277.5 157.417H275.535L277.45 157.025L278.383 156.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 156.779L272 157.025H273.326H274.652L273.375 157.319H272.687H272C271.117 157.368 270.232 157.368 269.348 157.319C268.451 157.237 267.564 157.072 266.697 156.828C265.816 156.63 264.959 156.333 264.144 155.945C265.027 155.894 265.912 155.894 266.795 155.945L269.447 156.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 140.239C274.794 140.234 276.946 140.414 279.071 140.779H290.659V145.245C290.364 149.025 283.048 153.196 272.638 153.196C262.229 153.196 254.912 149.025 254.618 145.245V140.779H266.206C268.33 140.414 270.483 140.234 272.638 140.239Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 148.632C288.25 148.949 287.872 149.228 287.467 149.466V140.779H288.597V148.632Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 140.632V152.804H266.108V140.779L267.237 140.632Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 153.147H268.023V140.534H269.201V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 150.448L258.3 149.81V140.779H259.479V150.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 153.147H269.987V140.386H271.116V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 149.27C257.117 148.986 256.739 148.674 256.385 148.337V140.779H257.515V149.27Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 151.969L262.229 151.577V140.779H263.358V151.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 152.46L264.144 152.166V140.779H265.273V152.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 151.331L260.461 150.84V140.779H261.59V151.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 151.675L281.624 152.018V140.779H282.803V151.675Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 153.147H273.866V140.288H274.995V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 140.239V153.147H271.902V140.239H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 145.245C290.541 146.208 290.11 147.105 289.431 147.798V140.779H290.659V145.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 147.454C255.054 146.836 254.711 146.065 254.618 145.245V140.779H255.6V147.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 150.006L285.503 150.595V140.779H286.682V150.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 153.147H275.83V140.386H276.959V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 150.939L283.588 151.429V140.779H284.718V150.939Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 152.215L279.709 152.509V140.779H280.838V152.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 152.656H277.745V140.386H278.874V152.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 132.288C283.245 132.288 290.659 136.607 290.659 140.436C290.659 144.264 283.245 148.632 272.638 148.632C262.032 148.632 254.618 144.313 254.618 140.436C254.618 136.558 262.032 132.288 272.638 132.288Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 146.571C283.132 147.082 281.851 147.492 280.544 147.798L265.813 133.074C267.237 132.828 268.71 132.632 270.331 132.485L284.374 146.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 148.632H271.411L258.448 135.675C259.065 135.309 259.705 134.981 260.363 134.693L274.111 148.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 147.896H279.316C279.955 147.896 280.593 147.601 281.182 147.356C281.803 147.211 282.411 147.014 282.999 146.767L283.883 146.423H284.325H284.767L286.485 145.589C287.642 144.99 288.728 144.266 289.726 143.429C288.988 144.552 288.037 145.519 286.927 146.276H286.142L285.258 146.767H284.816H284.325L283.392 147.16L282.459 147.454L281.231 148.239C280.588 148.422 279.931 148.553 279.267 148.632C278.629 148.632 277.941 148.632 277.303 148.632H275.339L277.254 148.239L278.383 147.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 148.239L272 148.485H273.326H274.652L273.375 148.779H272.687H272C271.118 148.853 270.231 148.853 269.348 148.779C268.451 148.697 267.564 148.533 266.697 148.288C265.816 148.09 264.959 147.794 264.144 147.405H266.795L269.447 148.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 131.454C274.794 131.448 276.946 131.629 279.071 131.994H290.659V136.46C290.364 140.239 283.048 144.411 272.638 144.411C262.229 144.411 254.912 140.239 254.618 136.46V131.994H266.206C268.33 131.629 270.483 131.448 272.638 131.454Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 139.847C288.25 140.163 287.872 140.443 287.467 140.681V131.994H288.597V139.847Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 131.847V144.018H266.108V131.994L267.237 131.847Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 144.215H268.023V131.748H269.201V144.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 141.663L258.3 141.025V131.994H259.479V141.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 144.362H269.987V131.552H271.116V144.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 140.485C257.117 140.201 256.739 139.889 256.385 139.552V131.994H257.515V140.485Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 143.331L262.229 142.939V132.141H263.358V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 143.626H264.144V131.994H265.273V143.626Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 142.497L260.461 142.055V132.239H261.59V142.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 142.89L281.624 143.233V131.994H282.803V142.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 144.313H273.866V131.454H274.995V144.313Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 131.454V144.411H271.902V131.454H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 136.46C290.519 137.43 290.091 138.336 289.431 139.061V131.994H290.659V136.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 138.669C255.054 138.05 254.711 137.28 254.618 136.46V131.994H255.6V138.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 141.221L285.503 141.81V131.994H286.682V141.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 144.166H275.83V131.601H276.959V144.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 142.153L283.588 142.644V131.994H284.718V142.153Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 143.331H279.709V131.994H280.838V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 143.871H277.745V131.798H278.874V143.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 123.699C283.245 123.699 290.659 127.969 290.659 131.896C290.659 135.822 283.245 140.043 272.638 140.043C262.032 140.043 254.618 135.724 254.618 131.896C254.618 128.068 262.032 123.699 272.638 123.699Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 137.785C283.124 138.274 281.845 138.684 280.544 139.012L265.813 124.288C267.307 124.007 268.815 123.811 270.331 123.699L284.374 137.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 139.847H271.411L258.448 126.89C259.065 126.523 259.705 126.195 260.363 125.908L274.111 139.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 139.11H279.316C279.955 139.11 280.593 138.816 281.182 138.571C281.771 138.325 282.41 138.178 282.999 137.982L283.883 137.638H284.325H284.767L286.485 136.804C287.642 136.205 288.728 135.481 289.726 134.644C288.988 135.766 288.037 136.733 286.927 137.491L286.092 138.031L285.209 138.521H284.767H284.276L283.343 138.914L282.41 139.209L281.428 139.454C280.784 139.637 280.128 139.768 279.464 139.847C278.825 139.847 278.138 139.847 277.5 139.847H275.535L277.45 139.454L278.383 139.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 139.209L272 139.454H273.326H274.652L273.375 139.748H272.687H272C271.117 139.797 270.232 139.797 269.348 139.748C268.451 139.666 267.564 139.502 266.697 139.258C265.816 139.059 264.959 138.763 264.144 138.374C265.027 138.323 265.912 138.323 266.795 138.374L269.447 139.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 122.669C274.794 122.663 276.946 122.844 279.071 123.209H290.659V127.626C290.364 131.454 283.048 135.626 272.638 135.626C262.229 135.626 254.912 131.454 254.618 127.626V123.209H266.206C268.33 122.844 270.483 122.663 272.638 122.669Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 131.061C288.25 131.378 287.872 131.658 287.467 131.896V123.209H288.597V131.061Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 123.061V135.233H266.108V123.209L267.237 123.061Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 135.429H268.023V122.963H269.201V135.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 132.877L258.3 132.239V123.209H259.479V132.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 135.577H269.987V122.816H271.116V135.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 131.699C257.117 131.416 256.739 131.104 256.385 130.767V123.209H257.515V131.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 134.399L262.229 134.006V123.209H263.358V134.399Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 134.89L264.144 134.595V123.209H265.273V134.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 133.515H260.264V123.209H261.59V133.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 134.104L281.624 134.448V123.209H282.803V134.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 135.528H273.866V122.669H274.995V135.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 122.669V135.626H271.902V122.669H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 127.626C290.552 128.605 290.119 129.521 289.431 130.227V123.209H290.659V127.626Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 129.883C255.044 129.252 254.701 128.462 254.618 127.626V123.209H255.6V129.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 132.436L285.503 133.025V123.209H286.682V132.436Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 135.38H275.83V122.816H276.959V135.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 133.515L283.588 134.006V123.209H284.718V133.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 134.644L279.709 134.939V123.209H280.838V134.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 135.086H277.745V122.816H278.874V135.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 114.718C283.245 114.718 290.659 118.988 290.659 122.865C290.659 126.742 283.245 131.061 272.638 131.061C262.032 131.061 254.618 126.742 254.618 122.865C254.618 118.988 262.032 114.718 272.638 114.718Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 129C283.124 129.489 281.845 129.899 280.544 130.227L265.813 115.503C267.307 115.222 268.815 115.025 270.331 114.914L284.374 129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 131.061H271.411L258.448 118.104C259.065 117.738 259.705 117.41 260.363 117.123L274.111 131.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 130.325H279.316C279.955 130.325 280.593 130.031 281.182 129.785C281.771 129.54 282.41 129.393 282.999 129.196L283.883 128.853H284.325H284.767L286.485 128.018C287.642 127.42 288.728 126.696 289.726 125.859C288.988 126.981 288.037 127.948 286.927 128.706L286.142 128.607L285.258 129.098H284.816H284.325L283.392 129.491L282.459 129.785L281.477 130.031C280.834 130.213 280.177 130.345 279.513 130.423C278.874 130.423 278.187 130.423 277.549 130.423H275.584L277.499 130.031L278.383 130.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 130.423L272 130.669H273.326H274.652L273.375 130.963H272.687H272C271.117 131.012 270.232 131.012 269.348 130.963C268.451 130.881 267.564 130.717 266.697 130.472C265.816 130.274 264.959 129.978 264.144 129.589C265.027 129.538 265.912 129.538 266.795 129.589L269.447 130.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 113.883C274.794 113.878 276.946 114.058 279.071 114.423H290.659V118.791C290.364 122.571 283.048 126.742 272.638 126.742C262.229 126.742 254.912 122.571 254.618 118.791V114.325H266.206C268.333 113.993 270.485 113.845 272.638 113.883Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 122.276C288.25 122.593 287.872 122.872 287.467 123.11V114.423H288.597V122.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 114.276V126.448H266.108V114.423L267.237 114.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 126.644H268.023V114.178H269.201V126.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 124.092L258.3 123.699V114.423H259.479V124.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 126.791H269.987V113.883H271.116V126.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 122.914C257.117 122.63 256.739 122.319 256.385 121.982V114.423H257.515V122.914Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 125.564L262.229 125.221V114.423H263.358V125.564Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 126.055L264.144 125.81V114.423H265.273V126.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 124.926L260.461 124.485V114.423H261.59V124.926Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 125.319L281.624 125.663V114.423H282.803V125.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 126.742H273.866V113.883H274.995V126.742Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 113.883V126.791H271.902V113.883H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 118.791C290.541 119.754 290.11 120.651 289.431 121.344V114.423H290.659V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 121.098C255.054 120.48 254.711 119.709 254.618 118.89V114.423H255.6V121.098Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 123.699L285.503 124.337V114.521H286.682V123.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 126.595H275.83V113.883H276.959V126.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 124.583L283.588 125.074V114.423H284.718V124.583Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 125.859L279.709 126.153V114.423H280.838V125.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 126.301H277.745V114.227H278.874V126.301Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 105.932C283.245 105.932 290.659 110.202 290.659 114.08C290.659 117.957 283.245 122.276 272.638 122.276C262.032 122.276 254.618 117.957 254.618 114.08C254.618 110.202 262.032 105.932 272.638 105.932Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 120.215C283.124 120.704 281.845 121.113 280.544 121.442L265.813 106.718C267.307 106.437 268.815 106.24 270.331 106.129L284.374 120.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 122.276H271.411L258.448 109.319C259.065 108.953 259.705 108.625 260.363 108.337L274.111 122.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 121.54H279.316C279.955 121.54 280.593 121.245 281.182 121C281.771 120.755 282.41 120.607 282.999 120.411L283.883 120.067H284.325H284.767L286.485 119.233C287.631 118.617 288.716 117.894 289.726 117.074C288.988 118.196 288.037 119.163 286.927 119.92L286.092 120.46L285.209 120.902L284.767 121.147H284.276L283.343 121.54L282.41 121.834L281.428 122.08C280.784 122.262 280.128 122.394 279.464 122.472C278.825 122.472 278.138 122.472 277.5 122.472H275.535L277.45 122.08L278.383 121.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 121.638L272 121.883H273.326H274.652L273.375 122.178H272.687H272C271.118 122.251 270.231 122.251 269.348 122.178C268.451 122.096 267.564 121.931 266.697 121.687C265.816 121.489 264.959 121.192 264.144 120.804C265.027 120.753 265.912 120.753 266.795 120.804L269.447 121.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 106.571C274.794 106.565 276.946 106.746 279.071 107.11H290.659V111.528C290.364 115.356 283.048 119.479 272.638 119.479C262.229 119.479 254.912 115.356 254.618 111.528V107.11H266.206C268.33 106.746 270.483 106.565 272.638 106.571Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 114.914C288.252 115.247 287.873 115.543 287.467 115.798V107.11H288.597V114.914Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 106.963V119.086H266.108V107.11L267.237 106.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 119.331H268.023V106.816H269.201V119.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 116.779L258.3 116.141V107.11H259.479V116.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 119.479H269.987V106.718H271.116V119.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 115.601C257.117 115.317 256.739 115.006 256.385 114.669V107.11H257.515V115.601Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 118.252L262.229 117.908V107.11H263.358V118.252Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 118.791H264.144V107.11H265.273V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 117.613L260.461 117.172V107.11H261.59V117.613Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 118.006L281.624 118.35V107.11H282.803V118.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 119.429H273.866V106.571H274.995V119.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 106.571V119.479H271.902V106.571H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 111.528C290.552 112.507 290.119 113.423 289.431 114.129V107.11H290.659V111.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 113.883C255.044 113.252 254.701 112.462 254.618 111.626V107.209H255.6V113.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 116.288L285.503 116.926V107.11H286.682V116.288Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 119.233H275.83V106.669H276.959V119.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 117.27L283.588 117.712V107.11H284.718V117.27Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 118.791L279.709 119.086V107.11H280.838V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 118.791H277.745V106.914H278.874V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 98.5706C283.245 98.5706 290.659 102.89 290.659 106.767C290.659 110.644 283.245 114.963 272.638 114.963C262.032 114.963 254.618 110.644 254.618 106.767C254.618 102.89 262.032 98.5706 272.638 98.5706Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 112.902C283.131 113.396 281.85 113.79 280.544 114.08L265.813 99.3558C267.303 99.0505 268.812 98.8537 270.331 98.7668L284.374 112.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 114.914H271.411L258.448 102.006C259.065 101.64 259.705 101.312 260.363 101.025L274.111 114.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 114.227H279.316L281.182 113.687C281.821 113.687 282.41 113.294 282.999 113.098L283.883 112.755H284.325L284.767 112.509C285.353 112.277 285.926 112.015 286.485 111.724C287.631 111.108 288.716 110.385 289.726 109.564C288.999 110.682 288.046 111.636 286.927 112.362C286.672 112.576 286.392 112.757 286.092 112.902L285.209 113.393L284.767 113.638H284.276L283.343 114.031L282.41 114.325L281.428 114.571L279.464 114.963C278.825 114.963 278.138 114.963 277.5 114.963H275.535L277.45 114.521L278.383 114.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 114.325L272 114.571H273.326H274.652L273.375 114.865H272.687H272C271.119 114.963 270.23 114.963 269.348 114.865C268.403 114.983 267.446 114.983 266.5 114.865C265.61 114.674 264.751 114.36 263.947 113.932C264.88 113.932 265.764 113.932 266.599 113.932L269.447 114.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 97.7853C274.794 97.7797 276.946 97.9603 279.071 98.3252H290.659V102.742C290.364 106.571 283.048 110.693 272.638 110.693C262.229 110.693 254.912 106.571 254.618 102.742V98.3252H266.206C268.33 97.9603 270.483 97.7797 272.638 97.7853Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 106.129C288.239 106.447 287.862 106.742 287.467 107.012V98.3251H288.597V106.129Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 98.1779V110.301H266.108V98.3252L267.237 98.1779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 110.546H268.023V98.0798H269.201V110.546Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 107.994L258.3 107.356V98.3251H259.479V107.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 110.693H269.987V97.9325H271.116V110.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 106.816C257.117 106.532 256.739 106.221 256.385 105.883V98.3251H257.515V106.816Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 109.466L262.229 108.975V98.1779H263.358V109.466Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 109.957L264.144 109.712V98.3251H265.273V109.957Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 108.975L260.461 108.534V98.3251H261.59V108.975Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 109.221L281.624 109.564V98.3251H282.803V109.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 110.644H273.866V97.7853H274.995V110.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 97.7853V110.693H271.902V97.7853H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 102.742C290.552 103.722 290.119 104.638 289.431 105.344V98.3251H290.659V102.742Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 105C255.044 104.368 254.701 103.579 254.618 102.742V98.3251H255.6V105Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 107.503L285.503 108.141V98.3251H286.682V107.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 110.448H275.83V97.8834H276.959V110.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 108.485L283.588 108.926V98.3251H284.718V108.485Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 109.761L279.709 110.006V98.3251H280.838V109.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 110.202H277.745V98.1288H278.874V110.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 106.178C282.591 106.178 290.659 102.508 290.659 97.9816C290.659 93.4549 282.591 89.7853 272.638 89.7853C262.686 89.7853 254.618 93.4549 254.618 97.9816C254.618 102.508 262.686 106.178 272.638 106.178Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 104.067C283.131 104.561 281.85 104.955 280.544 105.245L265.813 90.5214C267.303 90.2161 268.812 90.0193 270.331 89.9325L284.374 104.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 106.129H271.411L258.448 93.2209L260.363 92.1902L274.111 106.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 105.442L279.316 105.196L281.182 104.706C281.821 104.706 282.41 104.313 282.999 104.117L283.883 103.773H284.325H284.767C285.353 103.541 285.926 103.279 286.485 102.988C287.631 102.371 288.716 101.648 289.726 100.828C288.999 101.946 288.046 102.899 286.927 103.626C286.672 103.84 286.392 104.021 286.092 104.166L285.209 104.656L284.767 104.902H284.276L283.343 105.295L282.41 105.589L281.428 105.834C280.788 106.024 280.129 106.14 279.464 106.178H277.5H275.535L277.45 105.736L278.383 105.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 105.54L272 105.785H273.326H274.652L273.375 106.08H272.687H272C271.119 106.178 270.23 106.178 269.348 106.08C268.45 106.037 267.56 105.888 266.697 105.638C265.807 105.447 264.947 105.133 264.144 104.706C265.077 104.706 265.96 104.706 266.795 104.706L269.447 105.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 89C274.794 88.9944 276.946 89.175 279.071 89.5399H290.659V93.957C290.364 97.7853 283.048 101.908 272.638 101.908C262.229 101.908 254.912 97.7853 254.618 93.957V89.3435H266.206C268.336 89.0444 270.488 88.9295 272.638 89Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 97.3436C288.239 97.6616 287.862 97.9566 287.467 98.227V89.3436H288.597V97.3436Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 89.3436V101.466H266.108V89.3436H267.237Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 101.761H268.023V89.3436H269.201V101.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 99.1595L258.3 98.5215V89.3436H259.479V99.1595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 101.908H269.987V89.3436H271.116V101.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 98.0307C257.117 97.7469 256.739 97.4353 256.385 97.0982V89.3436H257.515V98.0307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 100.681L262.229 100.337V89.3436H263.358V100.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 101.172L264.144 100.926V89.3436H265.273V101.172Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 100.043L260.461 99.5522V89.3436H261.59V100.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 100.436L281.624 100.779V89.3436H282.803V100.436Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 101.859H273.866V89H274.995V101.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 89V101.908H271.902V89H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 93.9571C290.552 94.9367 290.119 95.8524 289.431 96.5583V89.3436H290.659V93.9571Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 96.2147C255.044 95.5832 254.701 94.7937 254.618 93.9571V89.3436H255.6V96.2147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 98.7178L285.503 99.3558V89.3436H286.682V98.7178Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 101.663H275.83V89.3436H276.959V101.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 99.6994L283.588 100.141V89.3436H284.718V99.6994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 100.975L279.709 101.221V89.3436H280.838V100.975Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 101.417H277.745V89.3436H278.874V101.417Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 81C283.245 81 290.659 85.319 290.659 89.1963C290.659 93.0736 283.245 97.3926 272.638 97.3926C262.032 97.3926 254.618 93.0736 254.618 89.1963C254.618 85.319 262.032 81 272.638 81Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 95.3313C283.131 95.8251 281.85 96.219 280.544 96.5092L265.813 81.7852C267.303 81.4799 268.812 81.2831 270.331 81.1963L284.374 95.3313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 97.3435H271.411L258.251 84.4356L260.166 83.4049L274.111 97.3435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 96.6564H279.316L281.182 96.1656L282.999 95.5767L283.883 95.2331H284.325H284.767C285.363 95.0049 285.937 94.7257 286.485 94.3988C287.64 93.8173 288.727 93.1095 289.726 92.2883C288.999 93.4064 288.046 94.3595 286.927 95.0859L286.092 95.6258L285.209 96.1165L284.767 96.3619H284.276L283.343 96.7546L282.41 97.0491L281.428 97.2945C280.783 97.4606 280.126 97.5755 279.464 97.638C278.811 97.711 278.152 97.711 277.5 97.638H275.535C276.174 97.638 276.812 97.3435 277.45 97.1963L278.383 96.6564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 96.7546H272H273.326L274.652 97L273.375 97.2945H272.687H272C271.119 97.3925 270.23 97.3925 269.348 97.2945C268.45 97.2514 267.56 97.1032 266.697 96.8527C265.814 96.6374 264.958 96.3246 264.144 95.9202C265.077 95.9202 265.96 95.9202 266.795 95.9202L269.447 96.7546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 80.2147C274.794 80.2091 276.946 80.3898 279.071 80.7546H290.659V85.1718C290.364 89 283.048 93.1227 272.638 93.1227C262.229 93.1227 254.912 89 254.618 85.1718V80.7546H266.206C268.33 80.3898 270.483 80.2091 272.638 80.2147Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.597 88.5583C288.239 88.8763 287.862 89.1713 287.467 89.4417V80.7546H288.597V88.5583Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.237 80.6074V92.7301H266.108V80.9509L267.237 80.6074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.201 92.9755H268.023V80.4601H269.201V92.9755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.479 90.4233L258.3 89.7853V80.7546H259.479V90.4233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.116 93.1227H269.987V80.3129H271.116V93.1227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.515 89.3435C257.117 89.0597 256.739 88.7481 256.385 88.411V80.7546H257.515V89.3435Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.358 91.8957L262.229 91.5521V80.7546H263.358V91.8957Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.273 92.3865L264.144 92.1411V80.7546H265.273V92.3865Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 91.2577L260.461 90.7669V80.9509H261.59V91.2577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.803 91.6503L281.624 91.9938V80.7546H282.803V91.6503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.995 93.0736H273.866V80.2147H274.995V93.0736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08 80.2147V93.1227H271.902V80.2147H273.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.659 85.1718C290.552 86.1514 290.119 87.0671 289.431 87.773V80.7546H290.659V85.1718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 87.4294C255.053 86.7927 254.71 86.0059 254.618 85.1718V80.7546H255.6V87.4294Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.682 89.9325L285.503 90.5705V80.7546H286.682V89.9325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.959 92.8773H275.83V80.3129H276.959V92.8773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.718 90.9141L283.588 91.3558V80.7546H284.718V90.9141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.838 92.1902L279.709 92.4356V80.7546H280.838V92.1902Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.874 92.6319H277.745V80.5583H278.874V92.6319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.638 72.2147C283.245 72.2147 290.659 76.5337 290.659 80.411C290.659 84.2883 283.245 88.6074 272.638 88.6074C262.032 88.6074 254.618 84.2883 254.618 80.411C254.618 76.5337 262.032 72.2147 272.638 72.2147Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284.374 86.546C283.131 87.0399 281.85 87.4337 280.544 87.7239L265.813 73C267.303 72.6947 268.812 72.4978 270.331 72.411L284.374 86.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M274.111 88.5583H271.411L258.448 75.6503L260.363 74.6196L274.111 88.5583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M278.383 87.8712L279.316 87.6258L281.182 87.135L282.999 86.546L283.883 86.2025H284.325H284.767L286.485 85.3681C287.64 84.7866 288.727 84.0788 289.726 83.2577C288.999 84.3758 288.046 85.3289 286.927 86.0552L286.092 86.5951L285.209 87.0859L284.767 87.3313H284.276L283.343 87.7239L282.41 88.0184H281.428C280.783 88.1845 280.126 88.2994 279.464 88.362H277.5H275.535L277.45 87.9203L278.383 87.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M269.447 87.9202L272 88.2147H273.326L274.652 88.4601L273.375 88.7546H272.687H272C271.119 88.8527 270.23 88.8527 269.348 88.7546C268.45 88.7116 267.56 88.5633 266.697 88.3129C265.814 88.0975 264.958 87.7847 264.144 87.3804C265.077 87.3804 265.96 87.3804 266.795 87.3804L269.447 87.9202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 183.92C297.299 183.913 299.468 184.093 301.609 184.46H313.197V188.926C312.902 192.706 305.635 196.877 295.176 196.877C284.718 196.877 277.499 192.706 277.205 188.926V184.46H288.793C290.885 184.101 293.004 183.92 295.127 183.92Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 192.411C310.771 192.728 310.376 193.008 309.956 193.245V184.46H311.135V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 184.313V196.485H288.597V184.46L289.775 184.313Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 196.681H290.561V184.215H291.69V196.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 194.129L280.839 193.491V184.46H281.968V194.129Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 196.828H292.476V184.068H293.654V196.828Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 192.951C279.63 192.68 279.235 192.367 278.874 192.018V184.46H280.053V192.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 195.65L284.718 195.258V184.46H285.847V195.65Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 196.092H286.682V184.46H287.811V196.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 194.963L282.803 194.521V184.706H283.932V194.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 195.356L304.162 195.699V184.46H305.292V195.356Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 196.779H296.404V183.92H297.533V196.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 183.92V196.877H294.44V183.92H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 188.926C313.079 189.889 312.648 190.785 311.97 191.478V184.46H313.246L313.197 188.926Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 191.135C277.575 190.501 277.252 189.736 277.156 188.926V184.46H278.138L278.089 191.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 193.687L308.041 194.276V184.46H309.171V193.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 196.632H298.319V184.068H299.448V196.632Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 194.62L306.077 195.11V184.46H307.256V194.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 195.896L302.198 196.19V184.46H303.327V195.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 196.337H300.283V184.264H301.413V196.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 175.969C305.783 175.969 313.197 180.288 313.197 184.117C313.197 187.945 305.783 192.411 295.127 192.411C284.472 192.411 277.107 188.092 277.107 184.215C277.107 180.337 284.521 175.969 295.127 175.969Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 190.252C305.646 190.74 304.35 191.15 303.033 191.479L288.302 176.755C289.775 176.449 291.269 176.252 292.77 176.166L306.912 190.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 192.411H293.703L280.789 179.454C281.384 179.078 282.008 178.749 282.655 178.472L296.601 192.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 191.577H301.805L303.671 191.037L305.488 190.448L306.372 190.104H306.814H307.256L308.974 189.27C310.115 188.671 311.186 187.946 312.166 187.11C311.438 188.241 310.485 189.21 309.367 189.957L308.532 190.497L307.649 190.988H307.207H306.765L305.832 191.38L304.899 191.675H303.917C303.272 191.853 302.616 191.984 301.953 192.067C301.314 192.067 300.627 192.067 299.989 192.067H297.975L299.89 191.675L300.872 191.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 191.675H294.538H295.864H297.19L295.962 192.411H295.324H294.636C293.738 192.485 292.834 192.485 291.936 192.411C291.04 192.319 290.153 192.155 289.284 191.92C288.419 191.722 287.578 191.425 286.78 191.037C287.663 190.988 288.548 190.988 289.431 191.037L291.936 191.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 175.135C297.299 175.128 299.468 175.308 301.609 175.675H313.197V180.141C312.902 183.92 305.635 188.092 295.176 188.092C284.718 188.092 277.499 183.92 277.205 180.141V175.675H288.793C290.885 175.316 293.004 175.135 295.127 175.135Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 183.528C310.771 183.845 310.376 184.124 309.956 184.362V175.675H311.135V183.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 175.528V187.503H288.597V175.675L289.775 175.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 187.896H290.561V175.429H291.69V187.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 185.344L280.839 184.705V175.675H281.968V185.344Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 188.043H292.476V175.233H293.654V188.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 184.166C279.63 183.894 279.235 183.582 278.874 183.233V175.675H280.053V184.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 186.865L284.718 186.472V175.675H285.847V186.865Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 187.503L286.682 187.258V175.675H287.811V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 186.178L282.803 185.736V175.92H283.932V186.178Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 186.571L304.162 186.914V175.675H305.292V186.571Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 187.994H296.404V175.135H297.533V187.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 175.135V188.092H294.44V175.135H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 180.141C313.079 181.103 312.648 182 311.97 182.693V175.675H313.246L313.197 180.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 182.595C277.575 181.962 277.252 181.196 277.156 180.386V175.92H278.138L278.089 182.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 184.853C308.811 185.094 308.434 185.308 308.041 185.491V175.675H309.171V184.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 187.847H298.319V175.282H299.448V187.847Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 185.834L306.077 186.325V175.675H307.256V185.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 187.11L302.198 187.405V175.675H303.327V187.11Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 187.503H300.283V175.479H301.413V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 167.184C305.783 167.184 313.197 171.454 313.197 175.331C313.197 179.209 305.783 183.528 295.127 183.528C284.472 183.528 277.107 179.209 277.107 175.331C277.107 171.454 284.521 167.184 295.127 167.184Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 181.466C305.646 181.955 304.35 182.365 303.033 182.693L288.302 167.969C289.779 167.688 291.271 167.491 292.77 167.38L306.912 181.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 183.528H293.703L280.789 170.571C281.384 170.194 282.008 169.866 282.655 169.589L296.601 183.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 182.595H301.805C302.444 182.595 303.033 182.301 303.671 182.055L305.488 181.466L306.372 181.123H306.814H307.256L308.974 180.288C310.115 179.689 311.186 178.965 312.166 178.129C311.438 179.259 310.485 180.228 309.367 180.975L308.532 181.515L307.649 181.957L307.207 182.202H306.765L305.783 182.595L304.85 182.89H303.868C303.223 183.068 302.567 183.199 301.904 183.282C301.265 183.282 300.578 183.282 299.939 183.282H297.926C298.554 183.104 299.194 182.973 299.841 182.89L300.872 182.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 182.89H294.538H295.864H297.19L295.864 183.184H295.226H294.538C293.639 183.234 292.737 183.234 291.838 183.184C290.942 183.092 290.055 182.928 289.186 182.693C288.32 182.495 287.48 182.198 286.682 181.81C287.565 181.761 288.45 181.761 289.333 181.81L291.936 182.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 166.35C297.299 166.342 299.468 166.523 301.609 166.89H313.197V171.356C312.902 175.135 305.635 179.307 295.176 179.307C284.718 179.307 277.499 175.135 277.205 171.356V166.89H288.793C290.885 166.53 293.004 166.35 295.127 166.35Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 174.693C310.785 175.041 310.388 175.338 309.956 175.577V166.89H311.135V174.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 166.742V178.914H288.597V166.89L289.775 166.742Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 179.11H290.561V166.644H291.69V179.11Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 176.558L280.839 175.92V166.89H281.968V176.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 179.258H292.476V166.497H293.654V179.258Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 175.38C279.63 175.109 279.235 174.797 278.874 174.448V166.89H280.053V175.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 178.031L284.718 177.687V166.89H285.847V178.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 178.521L286.682 178.276V166.89H287.811V178.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 177.393L282.803 176.951V166.89H283.932V177.393Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 177.687L304.162 178.031V166.89H305.292V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 179.209H296.404V166.35H297.533V179.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 166.35V179.258H294.44V166.35H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 171.356C313.079 172.318 312.648 173.215 311.97 173.908V166.89H313.246L313.197 171.356Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 173.564C277.575 172.931 277.252 172.165 277.156 171.356V166.89H278.138L278.089 173.564Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 176.067C308.811 176.309 308.434 176.522 308.041 176.705V166.89H309.171V176.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 179.061H298.319V166.448H299.448V179.061Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 177.049L306.077 177.491V166.89H307.256V177.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 178.325L302.198 178.62V166.89H303.327V178.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 178.767H300.283V166.693H301.413V178.767Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 158.35C305.783 158.35 313.197 162.669 313.197 166.546C313.197 170.423 305.783 174.742 295.127 174.742C284.472 174.742 277.107 170.423 277.107 166.546C277.107 162.669 284.521 158.35 295.127 158.35Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 172.779C305.652 173.273 304.355 173.667 303.033 173.957L288.302 159.233C289.775 158.928 291.269 158.731 292.77 158.644L306.912 172.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 174.742H293.703L280.789 161.834C281.384 161.458 282.008 161.13 282.655 160.853L296.601 174.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 174.006H301.805L303.671 173.466L305.783 172.779L306.667 172.436H307.109H307.55L309.269 171.601C310.399 170.985 311.468 170.261 312.461 169.442C311.749 170.572 310.792 171.528 309.662 172.239C309.405 172.464 309.125 172.661 308.827 172.828L307.943 173.27L307.501 173.515H307.059L306.126 173.908L305.193 174.202H304.211C303.567 174.38 302.911 174.512 302.247 174.595C301.609 174.595 300.922 174.595 300.283 174.595H298.27L300.185 174.153L300.872 174.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 174.104H294.538H295.864H297.19L295.864 174.399H295.226H294.538C293.639 174.472 292.736 174.472 291.838 174.399C290.942 174.307 290.055 174.143 289.186 173.908C288.32 173.71 287.48 173.413 286.682 173.025C287.565 172.976 288.45 172.976 289.333 173.025L291.936 174.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 157.564C297.299 157.557 299.468 157.738 301.609 158.104H313.197V162.521C312.902 166.35 305.635 170.521 295.176 170.521C284.718 170.521 277.499 166.35 277.205 162.521V158.055H288.793C290.887 157.712 293.006 157.548 295.127 157.564Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 165.908C310.773 166.241 310.378 166.537 309.956 166.791V158.055H311.135V165.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 158.055V170.227H288.597V158.055H289.775Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 170.325H290.561V158.055H291.69V170.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 167.871L280.839 167.233V158.055H281.968V167.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 170.472H292.476V157.712H293.654V170.472Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 166.595C279.63 166.324 279.235 166.011 278.874 165.663V158.055H280.053V166.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 169.245L284.718 168.902V158.055H285.847V169.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 169.736L286.682 169.491V158.055H287.811V169.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 168.607L282.803 168.166V158.055H283.932V168.607Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 169L304.162 169.344V158.055H305.292V169Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 170.423H296.404V157.564H297.533V170.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 157.564V170.521H294.44V157.564H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 162.521C313.09 163.501 312.658 164.417 311.97 165.123V158.055H313.246L313.197 162.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 164.779C277.564 164.133 277.24 163.349 277.156 162.521V158.055H278.138L278.089 164.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 167.282C308.811 167.524 308.434 167.737 308.041 167.92V158.055H309.171V167.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 170.227H298.319V157.663H299.448V170.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 168.264L306.077 168.705V158.055H307.256V168.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 169.54L302.198 169.834V158.055H303.327V169.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 169.982H300.283V158.055H301.413V169.982Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 149.564C305.783 149.564 313.197 153.883 313.197 157.761C313.197 161.638 305.783 165.957 295.127 165.957C284.472 165.957 277.107 161.638 277.107 157.761C277.107 153.883 284.521 149.564 295.127 149.564Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 163.896C305.652 164.389 304.355 164.783 303.033 165.074L288.302 150.35C289.775 150.044 291.269 149.848 292.77 149.761L306.912 163.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 165.957H293.703L280.789 153.147C281.384 152.771 282.008 152.443 282.655 152.166L296.601 165.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 165.221L301.805 164.975L303.671 164.485L305.488 163.896L306.372 163.552H306.814L307.256 163.307C307.846 163.086 308.421 162.823 308.974 162.521C310.105 161.905 311.173 161.182 312.166 160.362C311.454 161.492 310.498 162.448 309.367 163.159C309.11 163.384 308.83 163.582 308.532 163.748L307.649 164.19L307.207 164.436H306.765L305.832 164.828L304.899 165.123H303.917C303.272 165.301 302.616 165.432 301.953 165.515C301.314 165.515 300.627 165.515 299.989 165.515H297.975C298.614 165.515 299.252 165.221 299.89 165.074L300.872 165.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 165.319L294.538 165.564H295.864H297.19C296.753 165.686 296.311 165.784 295.864 165.859H295.226H294.538C293.639 165.932 292.736 165.932 291.838 165.859C290.942 165.767 290.055 165.603 289.186 165.368C288.319 165.152 287.479 164.84 286.682 164.436H289.333L291.936 165.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 148.779C297.299 148.772 299.468 148.952 301.609 149.319H313.197V153.736C312.902 157.564 305.635 161.736 295.176 161.736C284.718 161.736 277.499 157.564 277.205 153.736V149.319H288.793C290.885 148.96 293.004 148.779 295.127 148.779Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 157.123C310.773 157.456 310.378 157.752 309.956 158.006V149.319H311.135V157.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 149.172V161.294H288.597V149.319L289.775 149.172Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 161.54H290.561V149.074H291.69V161.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 158.988L280.839 158.35V149.319H281.968V158.988Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 161.687H292.476V148.926H293.654V161.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 158.055C279.63 157.784 279.235 157.472 278.874 157.123V149.319H280.053V158.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 160.46L284.718 160.117V149.319H285.847V160.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 160.951L286.682 160.706V149.319H287.811V160.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 159.822L282.803 159.38V149.319H283.932V159.822Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 160.215L304.162 160.558V149.319H305.292V160.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 161.638H296.404V148.779H297.533V161.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 148.779V161.687H294.44V148.779H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 153.736C313.09 154.716 312.658 155.632 311.97 156.337V149.319H313.246L313.197 153.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 155.994C277.564 155.348 277.24 154.564 277.156 153.736V149.319H278.138L278.089 155.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 158.497C308.811 158.738 308.434 158.952 308.041 159.135V149.319H309.171V158.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 161.442H298.319V148.877H299.448V161.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 159.479L306.077 159.92V149.319H307.256V159.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 160.755L302.198 161.049V149.319H303.327V160.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 161.196H300.283V149.123H301.413V161.196Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 140.779C305.783 140.779 313.197 145.098 313.197 148.975C313.197 152.853 305.783 157.172 295.127 157.172C284.472 157.172 277.107 152.853 277.107 148.975C277.107 145.098 284.521 140.779 295.127 140.779Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 155.11C305.652 155.604 304.355 155.998 303.033 156.288L288.302 141.564C289.775 141.259 291.269 141.062 292.77 140.975L306.912 155.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 157.123H293.703L280.789 144.215L282.655 143.184L296.601 157.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 156.436H301.805L303.671 155.896L305.783 155.11L306.667 154.767H307.108H307.55C308.14 154.767 308.68 154.227 309.269 153.982C310.399 153.365 311.468 152.642 312.461 151.822C311.749 152.952 310.792 153.908 309.662 154.62C309.415 154.844 309.133 155.026 308.827 155.16L307.943 155.65L307.501 155.896H307.059L305.783 156.092L304.85 156.387L303.868 156.632C303.223 156.81 302.567 156.941 301.904 157.025C301.265 157.025 300.578 157.025 299.939 157.025H297.926C298.565 157.025 299.203 156.73 299.841 156.583L300.872 156.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 156.534H294.538H295.864H297.19C296.753 156.655 296.311 156.754 295.864 156.828H295.226H294.538C292.74 156.928 290.936 156.762 289.186 156.337C288.313 156.142 287.47 155.828 286.682 155.405C287.566 155.405 288.449 155.405 289.333 155.405L291.936 156.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 139.994C297.299 139.986 299.468 140.167 301.609 140.534H313.197V144.951C312.853 148.779 305.783 153.147 295.127 153.147C284.472 153.147 277.45 148.975 277.156 145.147V140.73H288.744C290.847 140.302 292.982 140.056 295.127 139.994Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 148.239L309.956 149.123V140.534H311.135V148.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 140.386V152.558H288.597V140.534L289.775 140.386Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 152.755H290.561V140.288H291.69V152.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 150.202L280.839 149.564V140.534H281.968V150.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 153.147H292.476V140.386H293.654V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 149.025C279.63 148.753 279.235 148.441 278.874 148.092V140.534H280.053V149.025Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 151.675L284.718 151.331V140.534H285.847V151.675Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 152.166L286.682 151.92V140.534H287.811V152.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 151.037L282.803 150.595V140.534H283.932V151.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 151.429L304.162 151.773V140.534H305.292V151.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 152.853H296.404V139.994H297.533V152.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 139.994V153.147H294.44V139.994H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 144.951C313.09 145.931 312.658 146.846 311.97 147.552V140.534H313.246L313.197 144.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 147.209C277.564 146.563 277.24 145.778 277.156 144.951V140.534H278.138L278.089 147.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 149.712C308.811 149.953 308.434 150.166 308.041 150.35V140.534H309.171V149.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 152.656H298.319V140.092H299.448V152.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 150.693L306.077 151.135V140.534H307.256V150.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 151.969H302.198V140.534H303.327V151.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 152.411H300.283V140.337H301.413V152.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 131.994C305.783 131.994 313.197 136.313 313.197 140.19C313.197 144.068 305.783 148.239 295.127 148.239C284.472 148.239 277.107 143.92 277.107 140.043C277.107 136.166 284.521 131.994 295.127 131.994Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 146.325C305.652 146.819 304.355 147.213 303.033 147.503L288.302 132.779C289.775 132.474 291.269 132.277 292.77 132.19L306.912 146.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 148.239H293.703L280.789 135.331L282.655 134.301L296.601 148.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 147.65L301.805 147.405L303.671 146.914L305.488 146.325L306.372 145.982H306.814H307.256L308.974 145.147C310.114 144.565 311.184 143.857 312.166 143.037C311.454 144.167 310.498 145.123 309.367 145.834C309.12 146.059 308.838 146.241 308.532 146.374L307.649 146.865L307.207 147.11H306.765L305.832 147.503L304.899 147.798L303.917 148.043C303.272 148.221 302.616 148.352 301.953 148.436C301.314 148.436 300.627 148.436 299.989 148.436H297.975C298.614 148.436 299.252 148.141 299.89 147.994L300.872 147.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 147.748L294.538 147.994L295.962 148.239L297.288 148.485L295.962 148.779H295.324H294.636C293.738 148.853 292.834 148.853 291.936 148.779C291.04 148.687 290.153 148.523 289.284 148.288C288.417 148.073 287.577 147.76 286.78 147.356C287.664 147.356 288.548 147.356 289.431 147.356L291.936 147.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 132.632C297.301 132.639 299.47 132.836 301.609 133.221H313.197V137.638C312.902 141.466 305.635 145.589 295.176 145.589C284.718 145.589 277.499 141.466 277.205 137.638V133.221H288.793C290.884 132.844 293.003 132.647 295.127 132.632Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 141.025L309.956 141.908V133.221H311.135V141.025Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 133.074V145.196H288.597V133.417L289.775 133.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 145.442H290.561V132.926H291.69V145.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 142.89L280.839 142.252V133.221H281.968V142.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 145.589H292.476V132.779H293.654V145.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 141.712C279.641 141.425 279.248 141.114 278.874 140.779V133.221H280.053V141.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 144.362L284.718 144.018V133.221H285.847V144.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 144.853H286.682V133.221H287.811V144.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 143.724L282.803 143.233V133.417H283.932V143.724Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 144.117L304.162 144.46V133.221H305.292V144.117Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 145.54H296.404V132.681H297.533V145.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 132.681V145.589H294.44V132.681H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 137.638C313.09 138.618 312.658 139.533 311.97 140.239V133.221H313.246L313.197 137.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 139.896C277.574 139.244 277.251 138.463 277.156 137.638V133.221H278.138L278.089 139.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 142.399L308.041 143.037V133.221H309.171V142.399Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 145.344H298.319V132.779H299.448V145.344Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 143.331L306.077 143.773V133.221H307.256V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 144.656L302.198 144.902V133.221H303.327V144.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 145.098H300.283V133.025H301.413V145.098Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 124.681C305.783 124.681 313.197 129 313.197 132.877C313.197 136.755 305.783 141.074 295.127 141.074C284.472 141.074 277.107 136.755 277.107 132.877C277.107 129 284.521 124.681 295.127 124.681Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 139.012C305.644 139.484 304.349 139.877 303.033 140.19L288.302 125.466C289.775 125.161 291.269 124.964 292.77 124.877L306.912 139.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 141.025H293.703L280.789 128.117L282.655 127.086L296.601 141.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 140.337L301.805 140.092L303.671 139.601L305.488 139.012L306.372 138.669H306.814H307.256L308.974 137.834C310.114 137.252 311.184 136.544 312.166 135.724C311.454 136.854 310.498 137.81 309.367 138.521L308.532 139.061L307.649 139.552L307.207 139.798H306.765L305.832 140.141L304.899 140.485L303.917 140.73C303.271 140.892 302.615 141.007 301.953 141.074H299.989H297.975C298.614 141.074 299.252 140.779 299.89 140.632L300.872 140.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 140.436L294.538 140.681H295.864L297.19 140.926L295.864 141.221H295.226H294.538C293.639 141.295 292.736 141.295 291.838 141.221C290.943 141.146 290.056 140.998 289.186 140.779C288.319 140.563 287.479 140.251 286.682 139.847C287.566 139.847 288.449 139.847 289.333 139.847L291.936 140.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 123.699C297.299 123.692 299.468 123.873 301.609 124.239H313.197V128.656C312.902 132.485 305.635 136.607 295.176 136.607C284.718 136.607 277.499 132.485 277.205 128.656V124.239H288.793C290.885 123.88 293.004 123.699 295.127 123.699Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 132.239L309.956 133.123V124.436H311.135V132.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 124.288V136.411H288.597V124.632L289.775 124.288Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 136.656H290.561V124.141H291.69V136.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 134.104L280.839 133.515V124.436H281.968V134.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 136.804H292.476V124.043H293.654V136.804Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 132.926C279.641 132.64 279.248 132.328 278.874 131.994V124.436H280.053V132.926Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 135.577L284.718 135.233V124.436H285.847V135.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 136.067L286.682 135.822V124.436H287.811V136.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 134.939L282.803 134.448V124.632H283.932V134.939Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 135.331L304.162 135.675V124.436H305.292V135.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 136.755H296.404V123.699H297.533V136.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 123.699V136.607H294.44V123.699H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 128.853C313.09 129.832 312.658 130.748 311.97 131.454V124.436H313.246L313.197 128.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 131.11C277.574 130.459 277.251 129.677 277.156 128.853V124.436H278.138L278.089 131.11Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 133.515L308.041 134.153V124.337H309.171V133.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 136.558H298.319V123.994H299.448V136.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 134.595L306.077 135.037V124.436H307.256V134.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 135.871L302.198 136.117V124.436H303.327V135.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 136.264H300.283V124.239H301.413V136.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 115.896C305.783 115.896 313.197 120.215 313.197 124.092C313.197 127.969 305.783 132.288 295.127 132.288C284.472 132.288 277.107 127.969 277.107 124.092C277.107 120.215 284.521 115.896 295.127 115.896Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 130.227C305.644 130.698 304.349 131.092 303.033 131.405L288.302 116.681C289.775 116.376 291.269 116.179 292.77 116.092L306.912 130.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 132.239H293.703L280.789 119.331L282.655 118.301L296.601 132.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 131.552L301.805 131.307L303.671 130.816L305.488 130.227L306.372 129.883H306.814H307.256L308.974 129.049C310.114 128.467 311.184 127.759 312.166 126.939C311.454 128.069 310.498 129.025 309.367 129.736L308.532 130.276L307.649 130.767L307.207 131.012H306.765L305.832 131.356L304.899 131.699L303.917 131.945C303.271 132.107 302.615 132.222 301.953 132.288C301.299 132.337 300.642 132.337 299.989 132.288H297.975C298.614 132.288 299.252 131.994 299.89 131.847L300.872 131.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 131.65L294.538 131.896H295.864H297.19L295.962 132.534H295.324H294.636C293.738 132.608 292.834 132.608 291.936 132.534C291.041 132.458 290.155 132.311 289.284 132.092C288.417 131.876 287.577 131.564 286.78 131.16C287.663 131.111 288.548 131.111 289.431 131.16L291.936 131.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 115.061C297.301 115.069 299.47 115.266 301.609 115.65H313.197V120.067C312.902 123.896 305.635 128.018 295.176 128.018C284.718 128.018 277.499 123.896 277.205 120.067V115.65H288.793C290.884 115.274 293.003 115.077 295.127 115.061Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 123.699L309.956 124.583V115.65H311.135V123.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 115.503V127.626H288.597V115.847L289.775 115.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 127.871H290.561V115.356H291.69V127.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 125.319L280.839 124.681V115.65H281.968V125.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 128.018H292.476V115.209H293.654V128.018Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 124.141C279.641 123.855 279.248 123.543 278.874 123.209V115.65H280.053V124.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 126.791L284.718 126.448V115.65H285.847V126.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 127.282L286.682 127.037V115.65H287.811V127.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 126.153L282.803 125.663V115.847H283.932V126.153Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 126.546L304.162 126.89V115.65H305.292V126.546Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 127.969H296.404V115.11H297.533V127.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 115.11V128.018H294.44V115.11H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 120.068C313.09 121.047 312.658 121.963 311.97 122.669V115.65H313.246L313.197 120.068Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 122.325C277.574 121.674 277.251 120.892 277.156 120.068V115.65H278.138L278.089 122.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 124.828L308.041 125.466V115.65H309.171V124.828Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 127.773H298.319V115.209H299.448V127.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 125.81L306.077 126.252V115.65H307.256V125.81Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 127.086H302.198V115.65H303.327V127.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 127.479H300.283V115.454H301.413V127.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 107.11C305.783 107.11 313.197 111.429 313.197 115.307C313.197 119.184 305.783 123.699 295.127 123.699C284.472 123.699 277.107 119.38 277.107 115.503C277.107 111.626 284.521 107.11 295.127 107.11Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 121.442C305.644 121.913 304.349 122.306 303.033 122.62L288.302 107.896C289.775 107.59 291.269 107.394 292.77 107.307L306.912 121.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 123.699H293.703L280.789 110.791L282.655 109.761L296.601 123.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 122.767H301.805L303.671 122.276L305.488 121.687L306.372 121.344H306.814H307.256L308.974 120.509C310.114 119.927 311.184 119.219 312.166 118.399C311.454 119.529 310.498 120.485 309.367 121.196L308.532 121.736L307.649 122.227L307.207 122.472H306.765L305.832 122.816L304.899 123.159L303.917 123.405C303.271 123.567 302.615 123.682 301.953 123.748C301.299 123.797 300.642 123.797 299.989 123.748H297.975C298.614 123.748 299.252 123.454 299.89 123.307L300.872 122.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 122.816L294.538 123.11H295.864L297.19 123.356L295.962 123.699H295.324H294.636C293.738 123.773 292.834 123.773 291.936 123.699C291.041 123.624 290.155 123.476 289.284 123.258C288.424 123.02 287.586 122.708 286.78 122.325C287.663 122.276 288.548 122.276 289.431 122.325L291.936 122.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 106.276C297.301 106.284 299.47 106.481 301.609 106.865H313.197V111.282C312.902 115.11 305.635 119.233 295.176 119.233C284.718 119.233 277.499 115.11 277.205 111.282V106.865H288.793C290.884 106.488 293.003 106.291 295.127 106.276Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.135 114.669L309.956 115.552V106.865H311.135V114.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 106.718V118.791H288.597V107.012L289.775 106.718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69 119.086H290.561V106.571H291.69V119.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.968 116.534L280.839 115.896V106.865H281.968V116.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.654 119.233H292.476V106.472H293.654V119.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.053 115.356C279.641 115.069 279.248 114.758 278.874 114.423V106.865H280.053V115.356Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.847 118.006L284.718 117.663V106.865H285.847V118.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.811 118.497L286.682 118.202V106.865H287.811V118.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.932 117.368L282.803 116.877V107.061H283.932V117.368Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.292 117.761L304.162 118.104V106.865H305.292V117.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.533 119.184H296.404V106.325H297.533V119.184Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.569 106.325V119.233H294.44V106.325H295.569Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.197 111.282C313.09 112.262 312.658 113.177 311.97 113.883V106.865H313.246L313.197 111.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.089 113.54C277.574 112.889 277.251 112.107 277.156 111.282V106.865H278.138L278.089 113.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.171 116.043C308.81 116.268 308.433 116.465 308.041 116.632V106.816H309.171V116.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.448 118.791H298.319V106.423H299.448V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.256 117.024L306.077 117.466V106.865H307.256V117.024Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 118.301L302.198 118.546V106.865H303.327V118.301Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.413 118.791H300.283V106.669H301.413V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 98.3251C305.783 98.3251 313.197 102.644 313.197 106.521C313.197 110.399 305.783 114.718 295.127 114.718C284.472 114.718 277.107 110.399 277.107 106.521C277.107 102.644 284.521 98.3251 295.127 98.3251Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.912 112.607C305.653 113.118 304.356 113.528 303.033 113.834L288.302 99.1104C289.775 98.8051 291.269 98.6082 292.77 98.5215L306.912 112.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.601 114.669H293.703L280.789 101.761L282.655 100.73L296.601 114.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M300.872 113.883H301.854L303.72 113.393L305.537 112.804L306.421 112.46H306.863H307.305L309.023 111.626C310.163 111.044 311.233 110.336 312.215 109.515C311.503 110.645 310.547 111.601 309.416 112.313L308.582 112.853L307.698 113.344H307.256H306.814L305.881 113.687L304.948 114.031H303.966C303.32 114.193 302.664 114.308 302.002 114.374C301.363 114.374 300.676 114.374 300.038 114.374H298.024C298.663 114.374 299.301 114.08 299.939 113.932L300.872 113.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M291.936 113.883L294.538 114.178H295.864L297.19 114.423L295.864 114.669H295.226H294.538C293.639 114.743 292.736 114.743 291.838 114.669C290.946 114.569 290.061 114.422 289.186 114.227C288.326 113.989 287.488 113.677 286.682 113.294C287.565 113.246 288.45 113.246 289.333 113.294L291.936 113.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 183.969C247.838 183.979 249.99 184.176 252.113 184.558H263.702V188.975C263.456 192.804 256.14 196.926 245.73 196.926C235.32 196.926 228.004 192.804 227.709 188.975V184.558H239.298C241.405 184.18 243.54 183.982 245.681 183.969Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 192.411L260.412 193.294V184.558H261.59V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 184.411V196.534H239.101V184.558L240.28 184.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 196.779H241.065V184.264H242.195V196.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 194.227L231.343 193.589V184.558H232.472V194.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 196.877H242.98V184.068H244.159V196.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 193.049C230.146 192.762 229.752 192.451 229.379 192.117V184.558H230.557V193.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 195.699L235.222 195.356V184.558H236.351V195.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 196.19L237.039 195.896V184.558H238.168L238.316 196.19Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 195.061L233.307 194.571V184.755H234.436V195.061Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 195.454L254.667 195.798V184.558H255.796V195.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 196.877H246.859V184.018H247.989L248.038 196.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 184.018V196.926H244.944V184.018H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 188.975C263.594 189.955 263.162 190.871 262.474 191.577V184.558H263.751L263.702 188.975Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 191.233C228.078 190.582 227.755 189.8 227.66 188.975V184.558H228.642L228.593 191.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 193.736L258.546 194.325V184.509H259.675V193.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 196.681H248.823V184.117H249.953V196.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 194.718L256.582 195.16V184.558H257.76V194.718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 195.994L252.703 196.239V184.558H253.881V195.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 196.386H250.64V184.362H251.77V196.386Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 176.018C256.287 176.018 263.702 180.337 263.702 184.215C263.702 188.092 256.287 192.411 245.681 192.411C235.075 192.411 227.611 188.092 227.611 184.215C227.611 180.337 235.026 176.018 245.681 176.018Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 190.301C256.158 190.811 254.861 191.222 253.537 191.528L238.807 176.804C240.28 176.498 241.773 176.301 243.275 176.215L257.417 190.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 192.411H244.208L231.294 179.503C231.877 179.093 232.502 178.747 233.16 178.472L247.105 192.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 191.675L252.359 191.429L254.225 190.939L256.042 190.35L256.925 190.006H257.367H257.809L259.528 189.172C260.676 188.579 261.762 187.872 262.769 187.061C262.011 188.17 261.043 189.121 259.921 189.859L259.086 190.399L258.202 190.89H257.76H257.318L256.385 191.233L255.452 191.577H254.47L252.506 191.92C251.868 191.92 251.18 191.92 250.542 191.92C249.872 191.969 249.199 191.969 248.529 191.92L250.444 191.528L251.426 191.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 191.724L245.043 192.018H246.368C246.818 192.052 247.262 192.135 247.694 192.264H246.368H245.73H245.043C244.144 192.337 243.241 192.337 242.342 192.264C241.451 192.164 240.566 192.017 239.69 191.822C238.83 191.584 237.992 191.272 237.186 190.89C238.069 190.841 238.955 190.841 239.838 190.89L242.44 191.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 175.184C247.838 175.194 249.99 175.391 252.113 175.773H263.702V180.19C263.456 184.018 256.14 188.141 245.73 188.141C235.32 188.141 228.004 184.018 227.709 180.19V175.773H239.298C241.405 175.394 243.54 175.197 245.681 175.184Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 183.577L260.412 184.46V175.773H261.59V183.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 175.577V187.748H239.101V175.969L240.28 175.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 187.994H241.065V175.479H242.195V187.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 185.393L231.343 184.804V175.773H232.472V185.393Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 188.141H242.98V175.38H244.159V188.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 184.264C230.146 183.977 229.752 183.666 229.379 183.331V175.773H230.557V184.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 186.914L235.222 186.571V175.773H236.351V186.914Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 187.503L237.039 187.11V175.773H238.168L238.316 187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 186.276L233.307 185.785V175.969H234.436V186.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 186.669L254.667 187.012V175.773H255.796V186.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 188.092H246.859V175.233H247.989L248.038 188.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 175.184V188.141H244.944V175.233H246.074V175.184Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 180.19C263.594 181.17 263.162 182.086 262.474 182.791V175.773H263.751L263.702 180.19Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 182.595C228.078 181.944 227.755 181.162 227.66 180.337V175.92H228.642L228.593 182.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 184.951L258.546 185.54V175.724H259.675V184.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 187.896H248.823V175.331H249.953V187.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 185.933L256.582 186.374V175.773H257.76V185.933Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 187.209L252.703 187.454V175.773H253.881V187.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 187.503H250.64V175.233H251.77V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 167.233C256.287 167.233 263.702 171.552 263.702 175.429C263.702 179.307 256.287 183.626 245.681 183.626C235.075 183.626 227.611 179.307 227.611 175.429C227.611 171.552 235.026 167.233 245.681 167.233Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 181.515C256.158 182.026 254.861 182.436 253.537 182.742L238.807 168.018C240.28 167.713 241.773 167.516 243.275 167.429L257.417 181.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 183.577H244.208L231.294 170.669C231.877 170.259 232.502 169.913 233.16 169.638L247.105 183.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 182.841H252.359L254.225 182.35L256.042 181.761L256.925 181.417H257.367H257.809L259.528 180.583C260.676 179.99 261.762 179.283 262.769 178.472C262.011 179.581 261.043 180.532 259.921 181.27L259.086 181.81L258.202 182.301H257.76H257.318L256.385 182.644L255.452 182.988L254.47 183.233L252.506 183.577C251.868 183.577 251.18 183.577 250.542 183.577C249.872 183.626 249.199 183.626 248.529 183.577L250.444 183.184L251.426 182.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 182.939L245.043 183.233H246.368C246.818 183.267 247.262 183.349 247.694 183.479H246.368H245.73H245.043C244.144 183.552 243.241 183.552 242.342 183.479L239.69 183.037C238.795 182.967 237.908 182.819 237.039 182.595C237.922 182.546 238.807 182.546 239.69 182.595L242.44 182.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 166.399C247.839 166.384 249.994 166.581 252.113 166.988H263.702V171.405C263.456 175.233 256.14 179.356 245.73 179.356C235.32 179.356 228.004 175.233 227.709 171.405V166.988H239.298C241.401 166.585 243.539 166.388 245.681 166.399Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 174.791L260.412 175.675V166.988H261.59V174.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 166.791V178.963H239.101V167.184L240.28 166.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 179.209H241.065V166.693H242.195V179.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 176.607C232.08 176.424 231.702 176.211 231.343 175.969V166.988H232.472V176.607Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 179.307H242.98V166.546H244.159V179.307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 175.479C230.146 175.192 229.752 174.881 229.379 174.546V166.988H230.557V175.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 178.129L235.222 177.687V166.89H236.351V178.129Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 178.62L237.039 178.325V166.988H238.168L238.316 178.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 177.687L233.307 177.196V167.38H234.436V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 177.687L254.667 178.031V166.988H255.796V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 179.307H246.859V166.448H247.989L248.038 179.307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 166.448V179.356H244.944V166.448H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 171.405C263.594 172.385 263.162 173.3 262.474 174.006V166.988H263.751L263.702 171.405Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 173.663C228.078 173.011 227.755 172.23 227.66 171.405V166.988H228.642L228.593 173.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 176.166L258.546 176.755V166.939H259.675V176.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 179.11H248.823V166.546H249.953V179.11Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 177.147L256.68 177.687V166.988H257.858L257.76 177.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 178.423L252.703 178.669V166.988H253.881V178.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 178.816H250.64V166.546H251.77V178.816Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 158.448C256.287 158.448 263.702 162.767 263.702 166.644C263.702 170.521 256.287 174.84 245.681 174.84C235.075 174.84 227.611 170.521 227.611 166.644C227.611 162.767 235.026 158.448 245.681 158.448Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 172.779C256.158 173.29 254.861 173.7 253.537 174.006L238.807 159.282C240.28 158.977 241.773 158.78 243.275 158.693L257.417 172.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 174.791H244.208L231.294 161.883C231.877 161.473 232.502 161.128 233.16 160.853L247.105 174.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 174.104L252.359 173.859L254.225 173.368L256.042 172.779L256.925 172.436H257.367H257.809L259.528 171.601C260.676 171.008 261.762 170.301 262.769 169.491C262.011 170.6 261.043 171.55 259.921 172.288L259.086 172.828L258.202 173.319H257.76H257.318L256.385 173.663L255.452 174.006L254.47 174.252L252.506 174.595C251.868 174.595 251.18 174.595 250.542 174.595C249.872 174.644 249.199 174.644 248.529 174.595L250.444 174.202L251.426 174.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 174.153H245.043H246.368C246.809 174.107 247.253 174.107 247.694 174.153L246.368 174.399H245.73H245.043C244.144 174.472 243.241 174.472 242.342 174.399L239.69 173.957C238.83 173.719 237.992 173.407 237.186 173.025C238.069 172.976 238.955 172.976 239.838 173.025L242.44 174.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 157.614C247.839 157.599 249.994 157.796 252.113 158.202H263.702V162.62C263.456 166.448 256.14 170.571 245.73 170.571C235.32 170.571 228.004 166.448 227.709 162.62V158.055H239.298C241.406 157.702 243.544 157.554 245.681 157.614Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 166.006L260.412 166.89V158.055H261.59V166.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 158.055V170.227H239.101V158.055H240.28Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 170.423H241.065V158.055H242.195V170.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 167.871C232.08 167.688 231.702 167.475 231.343 167.233V158.055H232.472V167.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 170.521H242.98V157.761H244.159V170.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 166.693C230.146 166.407 229.752 166.095 229.379 165.761V158.055H230.557V166.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 169.344L235.222 169V158.055H236.351V169.344Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 169.834L237.039 169.54V158.055H238.168L238.316 169.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 168.705L233.307 168.215V158.055H234.436V168.705Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 169.098L254.667 169.442V158.055H255.796V169.098Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 170.521H246.859V157.663H247.989L248.038 170.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 157.614V170.571H244.944V157.614H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 162.62C263.594 163.599 263.162 164.515 262.474 165.221V158.055H263.751L263.702 162.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 164.877C228.078 164.226 227.755 163.444 227.66 162.62V158.055H228.642L228.593 164.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 167.38L258.546 167.969V158.055H259.675V167.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 170.325H248.823V157.761H249.953V170.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 168.362L256.582 168.804V158.055H257.76V168.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 169.638H252.703V158.055H253.881V169.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 170.031H250.64V158.055H251.77V170.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 149.663C256.287 149.663 263.702 153.982 263.702 157.859C263.702 161.736 256.287 166.055 245.681 166.055C235.075 166.055 227.611 161.736 227.611 157.859C227.611 153.982 235.026 149.663 245.681 149.663Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 163.945C256.158 164.455 254.861 164.866 253.537 165.172L238.807 150.448C240.28 150.143 241.773 149.946 243.275 149.859L257.417 163.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 166.006H244.208L231.294 153.147C231.889 152.771 232.513 152.443 233.16 152.166L247.105 166.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 165.27H252.359L254.225 164.779L256.042 164.19L256.925 163.847H257.367H257.809L259.528 163.012C260.676 162.419 261.762 161.712 262.769 160.902C262.011 162.011 261.043 162.961 259.921 163.699L259.086 164.239L258.202 164.73H257.76H257.318L256.385 165.074L255.452 165.417L254.47 165.663L252.506 166.006C251.868 166.006 251.18 166.006 250.542 166.006C249.872 166.055 249.199 166.055 248.529 166.006L250.444 165.614L251.426 165.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 165.368H245.043H246.368C246.809 165.321 247.253 165.321 247.694 165.368L246.368 165.613H245.73H245.043C244.144 165.687 243.241 165.687 242.342 165.613L239.69 165.172C238.83 164.934 237.992 164.622 237.186 164.239C238.069 164.19 238.955 164.19 239.838 164.239L242.44 165.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 148.828C247.839 148.813 249.994 149.011 252.113 149.417H263.702V153.834C263.456 157.613 256.14 161.785 245.73 161.785C235.32 161.785 228.004 157.613 227.709 153.834V149.417H239.298C241.401 149.015 243.539 148.818 245.681 148.828Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 157.221L260.412 158.104V149.417H261.59V157.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 149.221V161.393H239.101V149.613L240.28 149.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 161.638H241.065V149.123H242.195V161.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 159.037C232.08 158.854 231.702 158.64 231.343 158.399V149.417H232.472V159.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 161.736H242.98V148.975H244.159V161.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 158.055L229.379 157.123V149.417H230.557V158.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 160.558L235.222 160.215V149.417H236.351V160.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 161.049L237.039 160.755V149.417H238.168L238.316 161.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 159.92L233.307 159.429V149.614H234.436V159.92Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 160.313L254.667 160.656V149.417H255.796V160.313Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 161.687H246.909V148.877H248.038V161.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 148.828V161.785H244.944V148.877H246.074V148.828Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 153.834C263.587 154.812 263.156 155.725 262.474 156.436V149.417H263.751L263.702 153.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 156.092C228.078 155.441 227.755 154.659 227.66 153.834V149.417H228.642L228.593 156.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 158.595L258.546 159.184V149.368H259.675V158.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 161.54H248.823V148.975H249.953V161.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 159.577L256.68 160.018V149.417H257.858L257.76 159.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 160.853H252.703V149.417H253.881V160.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 161.245H250.64V148.975H251.77V161.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 140.877C256.287 140.877 263.702 145.196 263.702 149.074C263.702 152.951 256.287 157.27 245.681 157.27C235.075 157.27 227.611 152.951 227.611 149.074C227.611 145.196 235.026 140.877 245.681 140.877Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 155.159C256.158 155.67 254.861 156.08 253.537 156.386L238.807 141.663C240.28 141.357 241.773 141.16 243.275 141.074L257.417 155.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 157.221H244.208L231.294 144.313C231.877 143.903 232.502 143.557 233.16 143.282L247.105 157.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 156.485H252.359L254.225 155.994L256.042 155.356L256.925 155.061H257.367H257.809L259.528 154.227C260.676 153.634 261.762 152.927 262.769 152.117C262.011 153.226 261.043 154.176 259.921 154.914L259.086 155.454L258.202 155.945H257.76L257.318 156.19L256.385 156.534L255.452 156.877L254.47 157.123L252.506 157.466C251.868 157.466 251.18 157.466 250.542 157.466C249.872 157.515 249.199 157.515 248.529 157.466L250.444 157.074L251.426 156.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 156.583L245.043 156.828H246.368H247.694C247.264 156.973 246.819 157.072 246.368 157.123H245.73H245.043C244.144 157.196 243.241 157.196 242.342 157.123C241.451 157.023 240.566 156.876 239.69 156.681C238.83 156.443 237.992 156.131 237.186 155.748H239.838L242.44 156.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 140.043C247.839 140.028 249.994 140.225 252.113 140.632H263.702V145.049C263.456 148.877 256.14 153 245.73 153C235.32 153 228.004 148.877 227.709 145.049V140.632H239.298C241.401 140.23 243.539 140.032 245.681 140.043Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 148.239L260.412 149.123V140.632H261.59V148.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 140.436V152.607H239.101V140.828L240.28 140.436Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 152.853H241.065V140.337H242.195V152.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 150.252C232.08 150.068 231.702 149.855 231.343 149.613V140.632H232.472V150.252Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 153.147H242.98V140.386H244.159V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 149.123L229.379 148.239V140.632H230.557V149.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 151.773L235.222 151.429V140.632H236.351V151.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 152.264L237.039 151.969V140.632H238.168L238.316 152.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 151.135L233.307 150.644V140.828H234.436V151.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 151.479L254.667 151.822V140.632H255.796V151.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 153.147H246.859V140.092H247.989L248.038 153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 140.043V153.147H244.944V140.043H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 145.049C263.594 146.029 263.162 146.944 262.474 147.65V140.632H263.751L263.702 145.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 147.307C228.078 146.655 227.755 145.874 227.66 145.049V140.632H228.642L228.593 147.307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 149.81L258.546 150.399V140.583H259.675V149.81Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 152.755H248.823V140.19H249.953V152.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 150.791L256.582 151.233V140.632H257.76V150.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 152.067H252.703V140.632H253.881V152.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 152.46H250.64V140.386H251.77V152.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 132.092C256.287 132.092 263.702 136.411 263.702 140.288C263.702 144.166 256.287 148.239 245.681 148.239C235.075 148.239 227.611 143.969 227.611 140.092C227.611 136.215 235.026 132.092 245.681 132.092Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 146.374C256.158 146.885 254.861 147.295 253.537 147.601L238.807 132.877C240.28 132.572 241.773 132.375 243.275 132.288L257.417 146.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 148.239H244.208L231.294 135.479C231.889 135.102 232.513 134.774 233.16 134.497L247.105 148.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 147.699H252.359L254.225 147.209L256.042 146.62L256.925 146.227H257.367H257.809L259.528 145.393C260.676 144.799 261.762 144.092 262.769 143.282C262.011 144.391 261.043 145.342 259.921 146.08L259.086 146.62L258.202 147.11H257.76H257.318L256.385 147.503L255.452 147.798L254.47 148.092L252.506 148.436C251.868 148.436 251.18 148.436 250.542 148.436C249.872 148.484 249.199 148.484 248.529 148.436L250.444 148.043L251.426 147.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 147.798L245.043 148.043H246.368C246.818 148.077 247.262 148.159 247.694 148.288L246.368 148.534H245.73H245.043C244.144 148.607 243.241 148.607 242.342 148.534C241.451 148.434 240.566 148.287 239.69 148.092C238.83 147.854 237.992 147.542 237.186 147.16C238.069 147.111 238.955 147.111 239.838 147.16L242.44 147.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 132.73C247.839 132.715 249.994 132.913 252.113 133.319H263.702V137.736C263.456 141.515 256.14 145.687 245.73 145.687C235.32 145.687 228.004 141.515 227.709 137.736V133.515H239.298C241.395 133.047 243.533 132.784 245.681 132.73Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 141.123C261.226 141.44 260.832 141.719 260.412 141.957V133.515H261.59V141.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 133.123V145.294H239.101V133.515L240.28 133.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 145.54H241.065V133.025H242.195V145.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 142.939C232.08 142.755 231.702 142.542 231.343 142.301V133.515H232.472V142.939Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 145.638H242.98V132.877H244.159V145.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 141.761C230.135 141.49 229.74 141.177 229.379 140.828V133.515H230.557V141.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 144.46L235.222 144.067V133.515H236.351V144.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 144.951L237.039 144.656V133.515H238.168L238.316 144.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 143.822L233.307 143.331V133.515H234.436V143.822Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 144.166L254.667 144.509V133.515H255.796V144.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 145.589H246.859V132.779H247.989L248.038 145.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 132.73V145.687H244.944V132.73H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 137.736C263.562 138.706 263.134 139.612 262.474 140.337V133.515H263.751L263.702 137.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 139.945C228.08 139.311 227.757 138.546 227.66 137.736V133.515H228.642L228.593 139.945Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 142.497L258.546 143.086V133.515H259.675V142.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 145.442H248.823V132.877H249.953V145.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 143.331L256.582 143.773V133.515H257.76V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 144.755L252.703 145V133.515H253.881V144.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 145.147H250.64V132.877L251.77 133.515V145.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 124.779C256.287 124.779 263.702 129.098 263.702 132.975C263.702 136.853 256.287 141.123 245.681 141.123C235.075 141.123 227.611 136.804 227.611 132.975C227.611 129.147 235.026 124.779 245.681 124.779Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 139.061C256.158 139.572 254.861 139.982 253.537 140.288L238.807 125.564C240.182 125.319 241.704 125.123 243.275 124.975L257.417 139.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 141.123H244.208L231.294 128.166C231.889 127.789 232.513 127.461 233.16 127.184L247.105 141.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 140.386H252.359C252.997 140.386 253.587 140.092 254.225 139.847C254.844 139.695 255.451 139.498 256.042 139.258L256.925 138.914H257.367H257.809L259.528 138.08C260.677 137.469 261.763 136.746 262.769 135.92C262.026 137.056 261.057 138.025 259.921 138.767L259.086 139.307L258.202 139.798H257.76H257.318L256.385 140.19L255.452 140.485L254.47 140.779L252.506 141.123C251.868 141.123 251.18 141.123 250.542 141.123H248.529L250.444 140.73L251.426 140.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 140.485H245.043H246.368H247.694C247.258 140.606 246.815 140.704 246.368 140.779H245.73H245.043C244.144 140.853 243.241 140.853 242.342 140.779C241.451 140.68 240.566 140.532 239.69 140.337C238.83 140.1 237.992 139.788 237.186 139.405H239.838L242.44 140.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 123.945C247.837 123.939 249.989 124.12 252.113 124.485H263.702V128.951C263.456 132.73 256.14 136.902 245.73 136.902C235.32 136.902 228.004 132.73 227.709 128.951V124.485H239.298C241.406 124.124 243.542 123.943 245.681 123.945Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 132.337L260.412 133.221V124.485H261.59V132.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 124.337V136.509H239.101V124.485L240.28 124.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 136.755H241.065V124.239H242.195V136.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 134.153C232.08 133.97 231.702 133.757 231.343 133.515V124.485H232.472V134.153Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 136.853H242.98V124.092H244.159V136.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 132.975L229.379 132.092V124.485H230.557V132.975Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 135.675L235.222 135.282V124.485H236.351V135.675Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 136.166L237.039 135.871V124.485H238.168L238.316 136.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 134.988L233.307 134.546V124.485H234.436V134.988Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 135.38L254.667 135.724V124.485H255.796V135.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 136.804H246.859V123.945H247.989L248.038 136.804Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 123.945V136.902H244.944V123.945H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 128.951C263.562 129.921 263.134 130.827 262.474 131.552V124.485H263.751L263.702 128.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 131.209C228.085 130.554 227.763 129.774 227.66 128.951V124.485H228.642L228.593 131.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 133.515L258.546 134.104V124.288H259.675V133.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 136.656H248.823V124.092H249.953V136.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 134.644L256.582 135.135V124.485H257.76V134.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 135.969L252.703 136.215V124.485H253.881V135.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 136.362H250.64V124.092H251.77V136.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 115.994C256.287 115.994 263.702 120.313 263.702 124.19C263.702 128.067 256.287 132.337 245.681 132.337C235.075 132.337 227.611 128.018 227.611 124.19C227.611 120.362 235.026 115.994 245.681 115.994Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 130.276C256.158 130.787 254.861 131.197 253.537 131.503L238.807 116.779C240.284 116.498 241.775 116.301 243.275 116.19L257.417 130.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 132.337H244.208L231.294 119.38C231.889 119.004 232.513 118.676 233.16 118.399L247.105 132.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 131.601H252.359C252.997 131.601 253.587 131.307 254.225 131.061L256.042 130.472L256.925 130.129H257.367H257.809L259.528 129.294C260.677 128.684 261.763 127.96 262.769 127.135C262.026 128.27 261.057 129.24 259.921 129.982L259.086 130.521L258.202 131.012H257.76H257.318L256.385 131.405L255.452 131.699L254.47 131.994L252.506 132.337C251.868 132.337 251.18 132.337 250.542 132.337H248.529L250.444 131.945L251.426 131.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 131.699L245.043 131.945H246.368H247.694C247.258 132.066 246.815 132.165 246.368 132.239H245.73H245.043C244.144 132.313 243.241 132.313 242.342 132.239C241.446 132.147 240.56 131.983 239.69 131.748C238.825 131.55 237.985 131.254 237.186 130.865H239.838L242.44 131.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 115.16C247.839 115.145 249.994 115.342 252.113 115.748H263.702V120.166C263.456 123.945 256.14 128.117 245.73 128.117C235.32 128.117 228.004 123.945 227.709 120.166V115.748H239.298C241.401 115.346 243.539 115.149 245.681 115.16Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 123.699C261.226 124.016 260.832 124.296 260.412 124.534V115.748H261.59V123.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 115.552V127.724H239.101V115.945L240.28 115.552Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 127.969H241.065V115.454H242.195V127.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 125.368C232.08 125.185 231.702 124.972 231.343 124.73V115.748H232.472V125.368Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 128.067H242.98V115.307H244.159V128.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 124.19C230.135 123.919 229.74 123.607 229.379 123.258V115.748H230.557V124.19Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 126.89L235.222 126.497V115.748H236.351V126.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 127.38L237.039 127.086V115.748H238.168L238.316 127.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 126.202L233.307 125.761V115.945H234.436V126.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 126.595L254.667 126.939V115.748H255.796V126.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 128.018H246.859V115.159H247.989L248.038 128.018Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 115.159V128.117H244.944V115.159H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 120.166C263.584 121.128 263.152 122.025 262.474 122.718V115.748H263.751L263.702 120.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 122.374C228.08 121.741 227.757 120.975 227.66 120.166V115.748H228.642L228.593 122.374Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 124.926L258.546 125.515V115.699H259.675V124.926Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 127.871H248.823V115.307H249.953V127.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 125.859L256.582 126.35V115.748H257.76V125.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 127.184L252.703 127.429V115.748H253.881V127.184Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 127.577H250.64V115.307H251.77V127.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 107.209C256.287 107.209 263.702 111.528 263.702 115.356C263.702 119.184 256.287 123.699 245.681 123.699C235.075 123.699 227.611 119.38 227.611 115.503C227.611 111.626 235.026 107.209 245.681 107.209Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 121.491C256.158 122.001 254.861 122.412 253.537 122.718L238.807 107.994C240.284 107.712 241.775 107.516 243.275 107.405L257.417 121.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 123.699H244.208L231.294 110.742C231.889 110.366 232.513 110.038 233.16 109.761L247.105 123.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 122.816H252.359C252.997 122.816 253.587 122.521 254.225 122.276L256.042 121.687L256.925 121.344H257.367H257.809L259.528 120.509C260.677 119.898 261.763 119.175 262.769 118.35C262.026 119.485 261.057 120.454 259.921 121.196L259.086 121.736L258.202 122.227H257.76H257.318L256.385 122.62L255.452 122.914L254.47 123.209L252.506 123.552C251.868 123.552 251.18 123.552 250.542 123.552H248.529L250.444 123.159L251.426 122.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 122.914L245.043 123.159H246.368H247.694L246.368 123.699H245.73H245.043C244.144 123.773 243.241 123.773 242.342 123.699C241.446 123.607 240.56 123.443 239.69 123.209C238.825 123.01 237.985 122.714 237.186 122.325H239.838L242.44 122.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 106.374C247.837 106.369 249.989 106.549 252.113 106.914H263.702V111.38C263.456 115.159 256.14 119.331 245.73 119.331C235.32 119.331 228.004 115.159 227.709 111.38V106.914H239.298C241.406 106.553 243.542 106.372 245.681 106.374Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 114.767C261.226 115.084 260.832 115.363 260.412 115.601V106.914H261.59V114.767Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28 106.767V118.791H239.101V106.914L240.28 106.767Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.195 119.135H241.065V106.669H242.195V119.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.472 116.583C232.08 116.4 231.702 116.186 231.343 115.945V106.914H232.472V116.583Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.159 119.282H242.98V106.521H244.159V119.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.557 115.405C230.135 115.134 229.74 114.821 229.379 114.472V106.914H230.557V115.405Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 118.104L235.222 117.712V106.914H236.351V118.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.316 118.791L237.039 118.301V106.914H238.168L238.316 118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 117.417L233.307 116.975V106.914H234.436V117.417Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.796 117.81L254.667 118.153V106.914H255.796V117.81Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 119.233H246.859V106.374H247.989L248.038 119.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.074 106.374V119.331H244.944V106.374H246.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 111.38C263.562 112.351 263.134 113.257 262.474 113.982V106.914H263.751L263.702 111.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.593 113.589C228.08 112.956 227.757 112.19 227.66 111.38V106.914H228.642L228.593 113.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.675 116.141L258.546 116.73V106.914H259.675V116.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 119.086H248.823V106.521H249.953V119.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 117.074L256.582 117.564V106.914H257.76V117.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.881 118.35L252.703 118.644V106.914H253.881V118.35Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77 118.791H250.64V106.521H251.77V118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.681 98.4233C256.287 98.4233 263.702 102.742 263.702 106.571C263.702 110.399 256.287 114.767 245.681 114.767C235.075 114.767 227.611 110.448 227.611 106.571C227.611 102.693 235.026 98.4233 245.681 98.4233Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.417 112.706C256.158 113.216 254.861 113.627 253.537 113.933L238.807 99.2086C240.284 98.927 241.775 98.7303 243.275 98.6196L257.417 112.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.105 114.767H244.208L231.294 101.81C231.889 101.433 232.513 101.105 233.16 100.828L247.105 114.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M251.426 113.883H252.359C252.997 113.883 253.587 113.589 254.225 113.344L256.042 112.755L256.925 112.411H257.367H257.809L259.528 111.577C260.677 110.966 261.763 110.243 262.769 109.417C262.013 110.542 261.046 111.508 259.921 112.264L259.086 112.804L258.202 113.245L257.76 113.491H257.318L256.385 113.883L255.452 114.178L254.47 114.423C253.826 114.601 253.17 114.732 252.506 114.816C251.868 114.816 251.18 114.816 250.542 114.816H248.529L250.444 114.423L251.426 113.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M242.44 114.129L245.043 114.374H246.368H247.694L246.368 114.669H245.73H245.043C244.144 114.742 243.241 114.742 242.342 114.669C241.446 114.577 240.56 114.413 239.69 114.178C238.798 114.181 237.909 114.082 237.039 113.883C237.922 113.834 238.807 113.834 239.69 113.883L242.44 114.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 205.025C306.663 205.034 308.815 205.231 310.938 205.613H322.527V210.031C322.232 213.859 314.916 217.982 304.506 217.982C294.096 217.982 286.78 213.859 286.485 210.031V205.613H298.024C300.164 205.234 302.333 205.037 304.506 205.025Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 213.417L319.384 214.301V205.613H320.514V213.417Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 205.466V217.589H297.975V205.81L299.105 205.466Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 217.834H299.743V205.319H300.872V217.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 215.282L290.168 214.644V205.613H291.346V215.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 217.982H301.854V205.221H302.984V217.982Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 214.104C288.986 213.818 288.609 213.506 288.253 213.172V205.613H289.382V214.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 216.951L294.047 216.607V205.81H295.226V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 217.245L295.962 216.951V205.613H297.092L297.141 217.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 216.117L292.132 215.626V205.81H293.261V216.117Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 216.509L313.492 216.853V205.613H314.621V216.509Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 217.932H305.783V205.074H306.912L306.863 217.932Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 205.074V217.982H303.769V205.074H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 210.031C322.373 211.006 321.928 211.913 321.25 212.632V205.613H322.527V210.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 212.288C286.903 211.637 286.58 210.855 286.485 210.031V205.613H287.418V212.288Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 214.791L317.371 215.38V205.564H318.5V214.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 217.736H307.649V205.172H308.827V217.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 215.773L315.456 216.215V205.613H316.585V215.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 216.951H311.528V205.613H312.706V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 217.442H309.564V205.417H310.693V217.442Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 197.319C315.112 197.319 322.527 201.638 322.527 205.515C322.527 209.393 315.112 213.712 304.506 213.712C293.9 213.712 286.485 209.393 286.485 205.515C286.485 201.638 293.851 197.319 304.506 197.319Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 211.356C314.983 211.867 313.686 212.277 312.362 212.583L297.632 197.859C299.105 197.554 300.598 197.357 302.1 197.27L316.242 211.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 213.417H302.886L289.972 200.509L291.837 199.479L305.783 213.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 212.73H311.184L313.05 212.239L314.867 211.65L315.603 211.061H316.045H316.487L318.206 210.227C319.354 209.634 320.44 208.927 321.446 208.117C320.72 209.235 319.766 210.188 318.648 210.914L317.764 211.454C317.502 211.645 317.223 211.809 316.929 211.945L316.438 212.19H315.996L315.063 212.534L314.13 212.877H313.148L311.184 213.221C310.53 213.27 309.874 213.27 309.22 213.221H307.256C307.894 213.221 308.532 212.926 309.171 212.779L310.251 212.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 212.779L303.868 213.074H305.193L306.519 213.319L305.193 213.614H304.555H303.868C302.069 213.713 300.266 213.548 298.515 213.123C297.655 212.885 296.817 212.573 296.011 212.19H298.663L301.265 212.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 196.239C306.663 196.249 308.815 196.446 310.938 196.828H322.527V201.245C322.232 205.074 314.916 209.196 304.506 209.196C294.096 209.196 286.78 205.074 286.485 201.245V196.828H298.024C300.164 196.448 302.333 196.251 304.506 196.239Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 204.632L319.384 205.515V196.828H320.514V204.632Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 196.681V208.804H297.975V196.828L299.105 196.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 209.049H299.743V196.534H300.872V209.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 206.497L290.168 205.859V196.828H291.346V206.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 209.196H301.854V196.337H302.984V209.196Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 205.319C288.986 205.033 288.609 204.721 288.253 204.387V196.828H289.382V205.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 207.969L294.047 207.626V196.828H295.226V207.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 208.46L295.962 208.166V196.828H297.092L297.141 208.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 207.135L292.132 206.644V196.828H293.261V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 207.724L313.492 208.067V196.828H314.621V207.724Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 209.147H305.783V196.288H306.912L306.863 209.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 196.288V209.196H303.769V196.288H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 201.245C322.373 202.221 321.928 203.128 321.25 203.847V196.828H322.527V201.245Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 203.503C286.903 202.852 286.58 202.07 286.485 201.245V196.828H287.418V203.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 206.006C318.14 206.231 317.762 206.428 317.371 206.595V196.779H318.5V206.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 208.951H307.649V196.386H308.827V208.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 207.135L315.456 207.577V196.828H316.585V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 208.264L311.528 208.509V196.828H312.706V208.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 208.656H309.564V196.632H310.693V208.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 188.288C315.112 188.288 322.527 192.607 322.527 196.485C322.527 200.362 315.112 204.681 304.506 204.681C293.9 204.681 286.485 200.362 286.485 196.485C286.485 192.607 293.851 188.288 304.506 188.288Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 202.571C314.983 203.081 313.686 203.492 312.362 203.798L297.632 189.074C299.105 188.768 300.598 188.571 302.1 188.485L316.242 202.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 204.632H302.886L289.972 191.724L291.837 190.693L305.783 204.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 203.945L311.184 203.699L313.05 203.209L314.867 202.62L315.603 202.227H316.045H316.487L318.206 201.393C319.354 200.799 320.44 200.092 321.446 199.282C320.72 200.4 319.766 201.353 318.648 202.08L317.764 202.62C317.502 202.81 317.223 202.975 316.929 203.11H316.438H315.996L315.063 203.454L314.13 203.798H313.148L311.184 204.141C310.546 204.141 309.858 204.141 309.22 204.141H307.256L309.171 203.699L310.251 203.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 203.994L303.868 204.288H305.193L306.519 204.534H305.193H304.555H303.868C302.969 204.607 302.066 204.607 301.167 204.534C300.276 204.434 299.391 204.287 298.515 204.092C297.648 203.876 296.808 203.563 296.011 203.159C296.894 203.111 297.78 203.111 298.663 203.159L301.265 203.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 187.503C306.663 187.513 308.815 187.71 310.938 188.092H322.527V192.411C322.232 196.239 314.916 200.362 304.506 200.362C294.096 200.362 286.78 196.239 286.485 192.411V187.994H298.024C300.167 187.647 302.336 187.483 304.506 187.503Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 195.847L319.384 196.73V188.043H320.514V195.847Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 187.847V200.018H297.975V188.239L299.105 187.847Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 200.264H299.743V187.748L300.872 187.503V200.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 197.663L290.168 197.319V188.043H291.346V197.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 200.411H301.854V187.503H302.984V200.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 196.534C288.986 196.247 288.609 195.936 288.253 195.601V188.043H289.382V196.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 199.184L294.047 198.841V188.043H295.226V199.184Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 199.675L295.962 199.38V188.043H297.092L297.141 199.675Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 198.546L292.132 198.055V188.239H293.261V198.546Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 198.939L313.492 199.282V188.043H314.621V198.939Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 200.362H305.783V187.503H306.912L306.863 200.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 187.503V200.411H303.769V187.503H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 192.411C322.373 193.387 321.928 194.293 321.25 195.012V188.043H322.527V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 194.718C286.903 194.067 286.58 193.285 286.485 192.46V188.043H287.418V194.718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 197.319L317.371 197.908V188.092H318.5V197.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 200.166H307.649V187.503H308.827V200.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 198.202L315.456 198.644V188.043H316.585V198.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 199.479L311.528 199.724V188.043H312.706V199.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 199.871H309.564V187.847H310.693V199.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 179.503C315.112 179.503 322.527 183.822 322.527 187.699C322.527 191.577 315.112 195.896 304.506 195.896C293.9 195.896 286.485 191.577 286.485 187.699C286.485 183.822 293.851 179.503 304.506 179.503Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 193.785C314.983 194.296 313.686 194.706 312.362 195.012L297.632 180.288C299.105 179.983 300.598 179.786 302.1 179.699L316.242 193.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 195.847H302.886L289.972 182.939C290.565 182.546 291.189 182.201 291.837 181.908L305.783 195.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 195.16L311.184 194.914L313.05 194.423L314.867 193.834L315.751 193.491H316.192H316.634L318.353 192.656C319.501 192.063 320.587 191.356 321.594 190.546C320.867 191.664 319.914 192.617 318.795 193.344L317.911 193.883C317.65 194.074 317.37 194.239 317.076 194.374H316.585H316.143L315.21 194.718L314.277 195.061L313.295 195.307L311.331 195.65C310.693 195.65 310.006 195.65 309.367 195.65H307.403L309.318 195.209L310.251 195.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 195.209L303.868 195.503H305.193L306.519 195.748H305.193H304.555H303.868C302.969 195.822 302.066 195.822 301.167 195.748L298.516 195.307C297.653 195.232 296.799 195.084 295.962 194.865C296.845 194.816 297.731 194.816 298.614 194.865L301.265 195.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 180.141C306.664 180.126 308.819 180.324 310.938 180.73H322.527V185.147C322.232 188.926 314.916 193.098 304.506 193.098C294.096 193.098 286.78 188.926 286.485 185.147V180.73H298.024C300.161 180.326 302.332 180.129 304.506 180.141Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 188.534L319.384 189.417V180.73H320.514V188.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 180.534V192.706H297.975V180.926L299.105 180.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 192.951H299.743V180.436H300.872V192.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 190.35L290.168 189.712V180.73H291.346V190.35Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 193.049H301.854V180.288H302.984V193.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 189.221C288.986 188.934 288.609 188.623 288.253 188.288V180.73H289.382V189.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 191.871L294.047 191.528V180.73H295.226V191.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 192.411L295.962 192.067V180.73H297.092L297.141 192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 191.233L292.132 190.742V180.926H293.261V191.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 191.626L313.492 191.969V180.73H314.621V191.626Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 193.049H305.783V180.19H306.912L306.863 193.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 180.141V193.098H303.769V180.19H304.948V180.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 185.147C322.373 186.123 321.928 187.03 321.25 187.748V180.73H322.527V185.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 187.503C286.903 186.852 286.58 186.07 286.485 185.245V180.828H287.418V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 189.908L317.371 190.497V180.681H318.5V189.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 192.853H307.649V180.288H308.827V192.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 190.89L315.456 191.331V180.73H316.585V190.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 192.411H311.528V180.73H312.706V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 192.411H309.564V180.141H310.693V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 172.19C315.112 172.19 322.527 176.509 322.527 180.386C322.527 184.264 315.112 188.583 304.506 188.583C293.9 188.583 286.485 184.264 286.485 180.386C286.485 176.509 293.851 172.19 304.506 172.19Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 186.472C314.983 186.983 313.686 187.393 312.362 187.699L297.632 172.975C299.105 172.67 300.598 172.473 302.1 172.386L316.242 186.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 188.534H302.886L289.972 175.626C290.554 175.216 291.18 174.87 291.837 174.595L305.783 188.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 187.798H311.184L313.05 187.307L314.867 186.669L315.751 186.374H316.192H316.634L318.353 185.54C319.501 184.947 320.587 184.24 321.594 183.429C320.854 184.537 319.903 185.488 318.795 186.227L317.911 186.767C317.65 186.958 317.37 187.122 317.076 187.258L316.585 187.503H316.143L315.21 187.896L314.277 188.239H313.295L311.331 188.583C310.693 188.583 310.006 188.583 309.367 188.583C308.713 188.633 308.057 188.633 307.403 188.583L309.318 188.19L310.251 187.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 187.896L303.868 188.141H305.193C305.643 188.175 306.087 188.257 306.519 188.386H305.193H304.555H303.868C302.969 188.46 302.066 188.46 301.167 188.386C300.276 188.287 299.391 188.14 298.516 187.945C297.653 187.87 296.799 187.722 295.962 187.503H298.614L301.265 187.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 171.356C306.664 171.341 308.819 171.538 310.938 171.945H322.527V176.362C322.232 180.19 314.916 184.313 304.506 184.313C294.096 184.313 286.78 180.19 286.485 176.362V171.945H298.024C300.161 171.541 302.332 171.343 304.506 171.356Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 179.748L319.384 180.632V171.945H320.514V179.748Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 171.748V183.92H297.975V172.141L299.105 171.748Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 184.166H299.743V171.65H300.872V184.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 181.564L290.168 180.926V171.945H291.346V181.564Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 184.264H301.854V171.503H302.984V184.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 180.436L288.253 179.503V171.945H289.382V180.436Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 183.086L294.047 182.595V171.798H295.226V183.086Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 183.577L295.962 183.282V171.945H297.092L297.141 183.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 182.595L292.132 182.104V172.288H293.261V182.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 182.595L313.492 182.988V171.945H314.621V182.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 184.215H305.734V171.405H306.863V184.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 171.356V184.313H303.769V171.356H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 176.362C322.373 177.338 321.928 178.244 321.25 178.963V171.945H322.527V176.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 178.62C286.903 177.968 286.58 177.187 286.485 176.362V171.945H287.418V178.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 181.123L317.371 181.712V171.896H318.5V181.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 184.067H307.649V171.503H308.827V184.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 182.104L315.603 182.595V171.945H316.733L316.585 182.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 183.38L311.528 183.626V171.945H312.706V183.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 183.773H309.564V171.503H310.693V183.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 163.405C315.112 163.405 322.527 167.724 322.527 171.601C322.527 175.479 315.112 179.798 304.506 179.798C293.9 179.798 286.485 175.479 286.485 171.601C286.485 167.724 293.851 163.405 304.506 163.405Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 177.687C314.983 178.198 313.686 178.608 312.362 178.914L297.632 164.19C299.105 163.885 300.598 163.688 302.1 163.601L316.242 177.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 179.748H302.886L289.972 166.84C290.554 166.43 291.18 166.085 291.837 165.81L305.783 179.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 179.012H311.184L313.05 178.521L314.867 177.883L315.751 177.589H316.192H316.634L318.353 176.755C319.501 176.161 320.587 175.454 321.594 174.644C320.854 175.752 319.903 176.703 318.795 177.442L317.911 177.982C317.65 178.172 317.37 178.337 317.076 178.472H316.585L316.143 178.718L315.21 179.061L314.277 179.405H313.295L311.331 179.748C310.693 179.748 310.006 179.748 309.367 179.748C308.713 179.799 308.057 179.799 307.403 179.748L309.318 179.356L310.251 179.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 179.11L303.868 179.356H305.193H306.519C306.089 179.5 305.645 179.599 305.193 179.65H304.555H303.868C302.969 179.724 302.066 179.724 301.167 179.65C300.276 179.551 299.391 179.403 298.515 179.209C297.655 178.971 296.817 178.659 296.011 178.276C296.894 178.227 297.78 178.227 298.663 178.276L301.265 179.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 162.571C306.664 162.556 308.819 162.753 310.938 163.16H322.527V167.577C322.232 171.356 314.916 175.528 304.506 175.528C294.096 175.528 286.78 171.356 286.485 167.577V162.963H298.024C300.167 162.625 302.338 162.493 304.506 162.571Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 170.963L319.384 171.847V162.963H320.514V170.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 162.963V175.135H297.975V162.963H299.105Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 175.38H299.743V162.963H300.872V175.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 172.779L290.168 172.141V162.963H291.346V172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 175.479H301.854V162.718H302.984V175.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 171.65C288.986 171.364 288.609 171.052 288.253 170.718V162.963H289.382V171.65Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 174.301L294.047 173.957V162.963H295.226V174.301Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 174.791L295.962 174.497V162.963H297.092L297.141 174.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 173.663L292.132 173.172V162.963H293.261V173.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 174.055L313.492 174.399V162.963H314.621V174.055Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 175.429H305.783V162.62H306.912L306.863 175.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 162.571V175.528H303.769V162.571H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 167.577C322.373 168.552 321.928 169.459 321.25 170.178V162.963H322.527V167.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 169.834C286.903 169.183 286.58 168.401 286.485 167.577V162.963H287.418V169.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 172.337L317.371 172.926V162.963H318.5V172.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 175.282H307.649V162.963H308.827V175.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 173.319L315.603 173.761V162.963H316.733L316.585 173.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 174.595L311.528 174.84V162.963H312.706V174.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 174.988H309.564V162.963H310.693V174.988Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 154.62C315.112 154.62 322.527 158.939 322.527 162.816C322.527 166.693 315.112 170.963 304.506 170.963C293.9 170.963 286.485 166.693 286.485 162.816C286.485 158.939 293.851 154.62 304.506 154.62Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 168.902C314.983 169.413 313.686 169.823 312.362 170.129L297.632 155.405C299.105 155.1 300.598 154.903 302.1 154.816L316.242 168.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 170.963H302.886L290.119 158.055C290.714 157.679 291.338 157.351 291.985 157.074L305.783 170.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 170.227H311.184L313.05 169.736L314.867 169.098C315.176 169.027 315.474 168.911 315.751 168.755H316.192H316.634L318.353 167.92C319.513 167.327 320.6 166.603 321.594 165.761C320.866 166.891 319.913 167.86 318.795 168.607L317.911 169.147C317.65 169.338 317.37 169.502 317.076 169.638H316.585H316.143L315.21 170.031L314.277 170.374L313.295 170.62L311.331 170.963C310.693 170.963 310.006 170.963 309.367 170.963C308.713 171.013 308.057 171.013 307.403 170.963L309.318 170.571L310.251 170.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 170.325H303.868H305.193C305.643 170.359 306.087 170.441 306.519 170.571H305.193H304.555H303.868C302.969 170.644 302.066 170.644 301.167 170.571L298.515 170.129C297.655 169.891 296.817 169.579 296.011 169.196C296.894 169.147 297.78 169.147 298.663 169.196L301.265 170.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 153.785C306.664 153.771 308.819 153.968 310.938 154.374H322.527V158.791C322.232 162.571 314.916 166.742 304.506 166.742C294.096 166.742 286.78 162.571 286.485 158.791V154.374H298.024C300.161 153.97 302.332 153.773 304.506 153.785Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.514 162.178L319.384 163.061V154.374H320.514V162.178Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.105 154.178V166.35H297.975V154.571L299.105 154.178Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.872 166.595H299.743V154.08H300.872V166.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.346 163.994L290.168 163.356V154.374H291.346V163.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.984 166.693H301.854V153.932H302.984V166.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 162.963L288.253 162.031V154.374H289.382V162.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.226 165.515L294.047 165.172V154.374H295.226V165.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.141 166.006L295.962 165.712V154.374H297.092L297.141 166.006Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.261 164.877L292.132 164.387V154.571H293.261V164.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.621 165.221L313.492 165.613V154.374H314.621V165.221Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 166.644H305.734V153.834H306.863V166.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.948 153.785V166.742H303.769V153.785H304.948Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.527 158.791C322.373 159.767 321.928 160.674 321.25 161.393V154.374H322.527V158.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.418 161.049C286.903 160.398 286.58 159.616 286.485 158.791V154.374H287.418V161.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 163.552L317.371 164.141V154.325H318.5V163.552Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.827 166.497H307.649V153.932H308.827V166.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.585 164.534L315.456 164.975V154.374H316.585V164.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.706 165.81L311.528 166.055V154.374H312.706V165.81Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.693 166.202H309.564V154.129H310.693V166.202Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.506 145.834C315.112 145.834 322.527 150.153 322.527 154.031C322.527 157.908 315.112 162.227 304.506 162.227C293.9 162.227 286.485 157.908 286.485 154.031C286.485 150.153 293.851 145.834 304.506 145.834Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316.242 160.117C314.983 160.627 313.686 161.037 312.362 161.344L297.632 146.62C299.11 146.355 300.601 146.175 302.1 146.08L316.242 160.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M305.783 162.178H302.886L290.119 149.221C290.714 148.844 291.338 148.516 291.985 148.239L305.783 162.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M310.251 161.442H311.184C311.822 161.442 312.461 161.147 313.05 160.902C313.669 160.75 314.276 160.553 314.867 160.313L315.751 160.018H316.192H316.634L318.353 159.184C319.513 158.591 320.6 157.867 321.594 157.025C320.866 158.155 319.913 159.124 318.795 159.871L317.911 160.411C317.65 160.602 317.37 160.766 317.076 160.902H316.585H316.143L315.21 161.294L314.277 161.638L313.295 161.883L311.331 162.227C310.693 162.227 310.006 162.227 309.367 162.227H307.403L309.318 161.834L310.251 161.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M301.265 161.54H303.868H305.193H306.519C306.089 161.685 305.645 161.783 305.193 161.834H304.555H303.868C302.969 161.908 302.066 161.908 301.167 161.834L298.515 161.393C297.655 161.155 296.817 160.843 296.011 160.46H298.663L301.265 161.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 204.141C254.22 204.136 256.372 204.316 258.497 204.681H270.085V209.147C269.79 212.926 262.474 217.098 252.064 217.098C241.655 217.098 234.338 212.926 234.044 209.147V204.681H245.632C247.756 204.316 249.909 204.136 252.064 204.141Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.023 212.534L266.893 213.368V204.681H268.023V212.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 204.534V216.951H245.73V204.681L246.859 204.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 216.951H247.449V204.436H248.578V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.905 214.35L237.726 213.712V204.681H238.905V214.35Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 216.951H249.413V204.19H250.542V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.039 213.172C236.631 212.901 236.253 212.588 235.91 212.239V204.681H237.039V213.172Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.784 215.871L241.655 215.479V204.681H242.784V215.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.699 216.362L243.57 216.067V204.681H244.699V216.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82 215.184L239.69 214.742V204.926H240.82V215.184Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.179 215.577L261.05 215.92V204.681H262.179V215.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.421 216.951H253.292V204.141H254.421V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.506 204.141V216.951H251.328V204.141H252.506Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.085 209.147C269.931 210.123 269.486 211.03 268.808 211.748V204.681H270.085V209.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.026 211.356C234.48 210.738 234.137 209.967 234.044 209.147V204.681H235.026V211.356Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.108 213.908L264.929 214.497V204.681H266.108V213.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.385 216.951H255.256V204.288H256.385V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.144 214.84L263.014 215.331V204.681H264.144V214.84Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.264 216.117L259.135 216.411V204.681H260.264V216.117Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 216.558H257.171V204.288H258.3V216.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 196.19C262.67 196.19 270.085 200.46 270.085 204.337C270.085 208.215 262.67 212.534 252.064 212.534C241.458 212.534 234.044 208.215 234.044 204.337C234.044 200.46 241.458 196.19 252.064 196.19Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.8 210.472C262.541 210.983 261.244 211.393 259.921 211.699L245.19 196.975C246.667 196.697 248.159 196.501 249.658 196.386L263.8 210.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.488 212.534H250.591L237.677 199.577C238.278 199.21 238.901 198.883 239.543 198.595L253.488 212.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.809 212.043H258.742C259.381 212.043 260.019 211.748 260.608 211.503C261.197 211.258 261.836 211.11 262.425 210.914L263.309 210.571H263.751H264.193L265.911 209.736C267.06 209.125 268.146 208.402 269.152 207.577C268.414 208.699 267.463 209.666 266.353 210.423L265.518 210.963L264.635 211.405H264.193H263.702L262.769 211.798L261.836 212.092L260.854 212.337C260.21 212.52 259.554 212.651 258.89 212.73C258.251 212.73 257.564 212.73 256.926 212.73H254.961L256.68 212.043H257.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M248.824 212.043L251.426 212.288H252.752H254.078L252.752 212.583H252.113H251.426C250.527 212.656 249.624 212.656 248.725 212.583C247.845 212.495 246.974 212.331 246.123 212.092C245.242 211.894 244.385 211.597 243.57 211.209C244.453 211.159 245.338 211.159 246.221 211.209L248.824 212.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 196.73C254.22 196.724 256.372 196.905 258.497 197.27H270.085V201.687C269.79 205.515 262.474 209.687 252.064 209.687C241.655 209.687 234.338 205.515 234.044 201.687V197.319H245.632C247.755 196.938 249.907 196.741 252.064 196.73Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.023 205.074C267.668 205.395 267.291 205.69 266.893 205.957V197.319H268.023V205.074Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 197.319V209.491H245.73V197.319H246.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 209.491H247.449V197.025H248.578V209.491Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.905 207.135L237.726 206.497V197.319H238.905V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 209.638H249.413V196.828H250.542V209.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.039 205.761C236.631 205.49 236.253 205.177 235.91 204.828V197.319H237.039V205.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.784 208.411L241.655 208.067V197.319H242.784V208.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.699 208.902H243.57V197.319H244.699V208.902Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82 207.773L239.69 207.135V197.319H240.82V207.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.179 208.166L261.05 208.509V197.319H262.179V208.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.421 209.589H253.292V196.73H254.421V209.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.506 196.73V209.638H251.328V196.73H252.506Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.085 201.687C269.96 202.672 269.511 203.587 268.808 204.288V197.319H270.085V201.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.026 203.945C234.47 203.313 234.127 202.524 234.044 201.687V197.319H235.026V203.945Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.108 206.448L264.929 207.086V197.319H266.108V206.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.385 209.393H255.256V196.828H256.385V209.393Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.144 207.429C263.779 207.606 263.402 207.754 263.014 207.871V197.319H264.144V207.429Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.264 208.706L259.135 209V197.319H260.264V208.706Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 209.147H257.171V197.319H258.3V209.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 188.73C262.67 188.73 270.085 193.049 270.085 196.926C270.085 200.804 262.67 205.123 252.064 205.123C241.458 205.123 234.044 200.804 234.044 196.926C234.044 193.049 241.458 188.73 252.064 188.73Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.8 203.061C262.54 203.555 261.243 203.949 259.921 204.239L245.19 189.515C246.664 189.213 248.157 189.016 249.658 188.926L263.8 203.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.488 205.074H250.591L237.677 192.411C238.278 192.045 238.901 191.717 239.543 191.429L253.488 205.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.809 204.386H258.742L260.608 203.896C261.246 203.896 261.836 203.503 262.425 203.307L263.309 202.963H263.751H264.193L265.911 202.129C267.05 201.501 268.134 200.779 269.152 199.969C268.415 200.878 267.516 201.644 266.5 202.227L265.666 202.816L264.782 203.258H264.34H263.849L262.916 203.65L261.983 203.945H261.001C260.358 204.127 259.701 204.259 259.037 204.337C258.399 204.337 257.711 204.337 257.073 204.337H255.109L257.024 203.896L257.809 204.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M248.824 204.485H251.426H252.752H254.078L252.752 204.779H252.113H251.426C250.527 204.853 249.624 204.853 248.725 204.779C247.845 204.691 246.974 204.527 246.123 204.288C245.233 204.097 244.373 203.783 243.57 203.356C244.503 203.356 245.337 203.356 246.221 203.356L248.824 204.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 189.319C254.22 189.313 256.372 189.494 258.497 189.859H270.085V194.276C269.79 198.104 262.474 202.227 252.064 202.227C241.655 202.227 234.338 198.104 234.044 194.276V189.859H245.632C247.756 189.494 249.909 189.313 252.064 189.319Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.023 197.663L266.893 198.546V189.859H268.023V197.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 189.712V201.834H245.73V190.055L246.859 189.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 202.227H247.449V189.564H248.578V202.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.905 199.528L237.726 198.89V189.859H238.905V199.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 202.227H249.413V189.417H250.542V202.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.039 198.35C236.643 198.063 236.266 197.752 235.91 197.417V189.859H237.039V198.35Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.784 201L241.655 200.656V189.859H242.784V201Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.699 201.491L243.57 201.245V189.859H244.699V201.491Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82 200.362L239.69 199.871V190.055H240.82V200.362Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.179 200.755L261.05 201.098V189.859H262.179V200.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.421 202.227H253.292V189.319H254.421V202.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.506 189.319V202.227H251.328V189.319H252.506Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.085 194.276C269.96 195.261 269.511 196.176 268.808 196.877V189.859H270.085V194.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.026 196.534C234.47 195.902 234.127 195.113 234.044 194.276V189.859H235.026V196.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.108 199.037L264.929 199.675V189.859H266.108V199.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.385 202.227H255.256V189.417H256.385V202.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.144 200.018L263.014 200.46V189.859H264.144V200.018Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.264 201.294H259.135V189.859H260.264V201.294Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 201.687H257.171V189.663H258.3V201.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 181.319C262.67 181.319 270.085 185.638 270.085 189.515C270.085 193.393 262.67 197.712 252.064 197.712C241.458 197.712 234.044 193.393 234.044 189.515C234.044 185.638 241.458 181.319 252.064 181.319Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.8 195.65C262.54 196.144 261.243 196.538 259.921 196.828L245.19 182.104C246.664 181.802 248.157 181.605 249.658 181.515L263.8 195.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.488 197.663H250.591L237.677 184.755L239.543 183.724L253.488 197.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.809 196.975H258.742L260.608 196.485L262.425 195.896L263.309 195.552H263.751H264.193L265.911 194.718C267.06 194.125 268.145 193.418 269.152 192.607C268.425 193.725 267.472 194.679 266.353 195.405L265.518 195.945L264.635 196.436L264.193 196.681H263.702L262.769 197.074L261.836 197.368H260.854C260.209 197.534 259.552 197.649 258.89 197.712H256.926H254.961L256.68 197.319L257.809 196.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M248.824 197.319H251.426H252.752H254.078L252.752 197.614H252.113H251.426C250.528 197.711 249.623 197.711 248.725 197.614C247.844 197.566 246.971 197.418 246.123 197.172C245.24 196.956 244.384 196.644 243.57 196.239C244.503 196.239 245.337 196.239 246.221 196.239L248.824 197.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 181.859C254.221 181.869 256.374 182.066 258.497 182.448H270.085V186.865C269.79 190.693 262.474 194.816 252.064 194.816C241.655 194.816 234.338 190.693 234.044 186.865V182.595H245.632C247.751 182.163 249.903 181.917 252.064 181.859Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.023 190.252L266.893 191.135V182.595H268.023V190.252Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 182.301V194.423H245.73V182.595L246.859 182.301Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 194.669H247.449V182.153H248.578V194.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.905 192.117L237.726 191.479V182.595H238.905V192.117Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 194.816H249.413V182.055H250.542V194.816Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.039 190.939C236.643 190.652 236.266 190.341 235.91 190.006V182.595H237.039V190.939Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.784 193.589L241.655 193.245V182.595H242.784V193.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.699 194.08L243.57 193.834V182.595H244.699V194.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82 192.951L239.69 192.46V182.595H240.82V192.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.179 193.344L261.05 193.687V182.595H262.179V193.344Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.421 194.767H253.292V181.908H254.421V194.767Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.506 181.908V194.816H251.328V181.908H252.506Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.085 186.865C269.96 187.85 269.511 188.765 268.808 189.466V182.595H270.085V186.865Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.026 189.123C234.479 188.486 234.136 187.699 234.044 186.865V182.595H235.026V189.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.108 191.626L264.929 192.215V182.595H266.108V191.626Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.385 194.571H255.256V182.006H256.385V194.571Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.144 192.411L263.014 192.853V182.595H264.144V192.411Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.264 193.883L259.135 194.129V182.595H260.264V193.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 194.276H257.171V182.252H258.3V194.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 173.908C262.67 173.908 270.085 178.227 270.085 182.104C270.085 185.982 262.67 190.301 252.064 190.301C241.458 190.301 234.044 185.982 234.044 182.104C234.044 178.227 241.458 173.908 252.064 173.908Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.8 188.19C262.541 188.701 261.244 189.111 259.921 189.417L245.19 174.693C246.664 174.391 248.157 174.194 249.658 174.104L263.8 188.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.488 190.252H250.591L237.677 177.344C238.277 176.961 238.9 176.616 239.543 176.313L253.488 190.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.809 189.564L258.742 189.319L260.608 188.828L262.425 188.239L263.309 187.896H263.751H264.193L265.911 187.061C267.059 186.468 268.145 185.761 269.152 184.951C268.432 185.957 267.533 186.822 266.5 187.503L265.666 188.043L264.782 188.534H264.34H263.849L262.916 188.877L261.983 189.221L261.001 189.466L259.037 189.81C258.399 189.81 257.711 189.81 257.073 189.81C256.419 189.86 255.762 189.86 255.109 189.81L257.024 189.417L257.809 189.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M248.824 189.613L251.426 189.908H252.752L254.078 190.153L252.752 190.448H252.113H251.426C250.527 190.521 249.624 190.521 248.725 190.448C247.847 190.376 246.976 190.229 246.123 190.006C245.24 189.791 244.384 189.478 243.57 189.074C244.453 189.023 245.338 189.023 246.221 189.074L248.824 189.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 174.448C254.223 174.433 256.377 174.63 258.497 175.037H270.085V179.454C269.79 183.282 262.474 187.405 252.064 187.405C241.655 187.405 234.338 183.282 234.044 179.454V175.037H245.632C247.751 174.63 249.906 174.433 252.064 174.448Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.023 182.84L266.893 183.724V175.037H268.023V182.84Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 174.84V187.012H245.73V175.233L246.859 174.84Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 187.503H247.449V174.742H248.578V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.905 184.656L237.726 184.018V175.037H238.905V184.656Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 187.503H249.413V174.742H250.542V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.039 183.528C236.643 183.241 236.266 182.93 235.91 182.595V175.037H237.039V183.528Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.784 186.178L241.655 185.834V175.037H242.784V186.178Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.699 186.669L243.57 186.374V175.037H244.699V186.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82 185.54L239.69 185.049V175.233H240.82V185.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.179 185.933L261.05 186.276V175.037H262.179V185.933Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.421 187.503H253.292V174.497H254.421V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.506 174.448V187.503H251.328V174.497H252.506V174.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.085 179.454C269.96 180.439 269.511 181.354 268.808 182.055V175.037H270.085V179.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.026 181.712C234.479 181.075 234.136 180.288 234.044 179.454V175.037H235.026V181.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.108 184.215L264.929 184.804V174.988H266.108V184.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.385 187.16H255.256V174.595H256.385V187.16Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.144 185.196L263.014 185.638V175.037H264.144V185.196Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.264 186.472L259.135 186.718V175.037H260.264V186.472Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 186.865H257.171V174.595H258.3V186.865Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.064 166.497C262.67 166.497 270.085 170.816 270.085 174.693C270.085 178.571 262.67 182.89 252.064 182.89C241.458 182.89 234.044 178.571 234.044 174.693C234.044 170.816 241.458 166.497 252.064 166.497Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.8 180.779C262.541 181.29 261.244 181.7 259.921 182.006L245.19 167.282C246.664 166.98 248.157 166.783 249.658 166.693L263.8 180.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.488 182.841H250.591L237.677 169.883C238.278 169.517 238.901 169.189 239.543 168.902L253.488 182.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M257.809 182.104H258.742L260.608 181.614L262.425 180.975L263.309 180.681H263.751H264.193L265.911 179.847C267.06 179.253 268.145 178.546 269.152 177.736C268.413 178.844 267.461 179.795 266.353 180.534L265.518 181.074L264.635 181.564H264.193H263.702L262.769 181.957L261.836 182.301L260.854 182.546L258.89 182.89C258.251 182.89 257.564 182.89 256.926 182.89C256.272 182.94 255.615 182.94 254.961 182.89L256.68 182.595L257.809 182.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M248.824 182.202H251.426H252.752H254.078C253.647 182.347 253.203 182.446 252.752 182.497H252.113H251.426C250.527 182.57 249.624 182.57 248.725 182.497C247.85 182.402 246.981 182.254 246.123 182.055C245.247 181.818 244.393 181.506 243.57 181.123C244.453 181.072 245.338 181.072 246.221 181.123L248.824 182.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 212.043C277.118 212.04 279.286 212.22 281.428 212.583H292.967V216.951C292.672 220.779 285.356 224.951 274.946 224.951C264.536 224.951 257.22 220.779 256.926 216.951V212.534H268.514C270.64 212.185 272.792 212.021 274.946 212.043Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 220.239C290.715 220.567 290.335 220.848 289.922 221.074V212.386H291.052V220.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 212.043V224.215H268.416V212.387L269.545 212.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 224.607H270.281V212.043H271.411V224.607Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 221.859C261.198 221.676 260.82 221.462 260.461 221.221V212.386H261.59V221.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 224.755H272.295V212.043H273.424V224.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 220.877C259.424 220.593 259.047 220.282 258.693 219.945V212.386H259.822V220.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 223.577L264.536 223.184V212.386H265.666V223.577Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 224.067L266.5 223.773V212.386H267.679L267.63 224.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 222.89L262.572 222.448V212.632H263.751V222.89Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 223.282L283.981 223.626V212.386H285.11V223.282Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 224.706H276.321V212.043H277.5L277.352 224.706Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 212.043V224.804H274.259V212.043H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 216.951C292.859 217.931 292.427 218.846 291.739 219.552V212.386H292.967V216.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 219.061C257.37 218.418 257.03 217.635 256.926 216.804V212.386H257.908V219.061Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 221.859L287.86 222.448V212.632H288.989V221.859Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 224.558H278.138V212.043H279.267V224.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 222.546L285.896 223.037V212.386H287.025V222.546Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 223.822L282.017 224.117V212.386H283.146V223.822Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 224.264H280.053V212.043H281.231V224.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 203.896C285.602 203.896 292.967 208.166 292.967 212.043C292.967 215.92 285.602 220.239 274.946 220.239C264.291 220.239 256.926 215.92 256.926 212.043C256.926 208.166 264.34 203.896 274.946 203.896Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 218.178C285.434 218.674 284.155 219.084 282.852 219.405L268.121 204.681C269.61 204.376 271.12 204.179 272.638 204.092L286.682 218.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 220.239H273.424L260.559 207.135C261.177 206.769 261.816 206.441 262.474 206.153L276.321 220.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 219.503H281.673C282.262 219.503 282.901 219.209 283.49 218.963C284.079 218.718 284.718 218.571 285.307 218.374L286.24 218.031H286.682H287.124L288.842 217.196C289.976 216.585 291.045 215.862 292.034 215.037C291.295 216.159 290.345 217.126 289.235 217.883L288.4 218.423L287.516 218.914H287.075H286.633L285.7 219.307L284.718 219.601L283.785 219.847C283.139 220.02 282.483 220.151 281.821 220.239H279.807H277.843L279.758 219.847L280.691 219.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 219.601L274.357 219.847H275.634H277.008L275.683 220.141H274.995H274.357C273.457 220.191 272.556 220.191 271.656 220.141C270.761 220.049 269.874 219.885 269.005 219.65C268.123 219.452 267.267 219.155 266.451 218.767C267.351 218.717 268.253 218.717 269.152 218.767L271.754 219.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 203.061C277.118 203.058 279.286 203.239 281.428 203.601H292.967V208.067C292.672 211.847 285.356 216.018 274.946 216.018C264.536 216.018 257.22 211.847 256.926 208.067V203.601H268.514C270.638 203.236 272.791 203.056 274.946 203.061Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 211.454C290.715 211.782 290.335 212.062 289.922 212.288V203.601H291.052V211.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 203.454V215.626H268.416V203.601L269.545 203.454Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 215.822H270.281V203.356H271.411V215.822Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 213.27L260.461 212.632V203.601H261.59V213.27Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 215.969H272.295V203.209H273.424V215.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 212.043C259.424 211.759 259.047 211.447 258.693 211.11V203.601H259.822V212.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 214.742L264.536 214.399V203.601H265.666V214.742Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 215.233H266.451V203.601H267.63V215.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 214.104L262.572 213.663V203.847H263.751V214.104Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 214.497L283.981 214.84V203.601H285.11V214.497Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 215.92H276.321V203.061H277.5L277.352 215.92Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 203.061V215.969H274.259V203.061H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 208.067C292.849 209.03 292.418 209.927 291.739 210.62V203.601H292.967V208.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 210.276C257.381 209.645 257.041 208.881 256.926 208.067V203.601H257.908V210.276Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 212.828L287.86 213.417V203.601H288.989V212.828Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 215.773H278.138V203.209H279.267V215.773Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 213.761L285.896 214.252V203.601H287.025V213.761Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 215.037L282.017 215.331V203.601H283.146V215.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 215.479H280.053V203.405H281.231V215.479Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 195.061C285.602 195.061 292.967 199.38 292.967 203.258C292.967 207.135 285.602 211.454 274.946 211.454C264.291 211.454 256.926 207.135 256.926 203.258C256.926 199.38 264.34 195.061 274.946 195.061Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 209.393C285.434 209.888 284.155 210.298 282.852 210.62L268.121 195.896C269.614 195.615 271.123 195.418 272.638 195.307L286.682 209.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 211.454H273.424L260.461 198.497C261.078 198.131 261.718 197.803 262.376 197.515L276.321 211.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 210.718H281.673C282.262 210.718 282.901 210.423 283.49 210.178C284.079 209.933 284.718 209.785 285.307 209.589L286.24 209.245H286.682H287.124L288.842 208.411C289.965 207.783 291.033 207.06 292.034 206.252C291.295 207.374 290.345 208.341 289.235 209.098L288.4 209.638L287.516 210.08H287.075H286.633L285.7 210.472L284.718 210.767L283.785 211.012C283.139 211.186 282.483 211.317 281.821 211.405H279.807H277.843L279.758 211.012L280.691 210.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 210.816H274.357H275.634H277.008L275.683 211.11H274.995H274.357C273.458 211.184 272.555 211.184 271.656 211.11C270.761 211.018 269.874 210.854 269.005 210.62C268.123 210.421 267.267 210.125 266.451 209.736C267.351 209.687 268.253 209.687 269.152 209.736L271.754 210.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 194.276C277.118 194.273 279.286 194.453 281.428 194.816H292.967V199.233C292.672 203.061 285.356 207.233 274.946 207.233C264.536 207.233 257.22 203.061 256.926 199.233V194.816H268.514C270.638 194.451 272.791 194.27 274.946 194.276Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 202.62C290.73 202.978 290.348 203.277 289.922 203.503V194.816H291.052V202.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 194.669V206.84H268.416V194.816L269.545 194.669Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 207.135H270.281V194.571H271.411V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 204.485C261.198 204.301 260.82 204.088 260.461 203.847V194.816H261.59V204.485Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 207.135H272.295V194.374H273.424V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 203.307C259.424 203.023 259.047 202.711 258.693 202.374V194.816H259.822V203.307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 205.957L264.536 205.613V194.816H265.666V205.957Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 206.448H266.451V194.816H267.63V206.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 205.319L262.572 204.877V195.061H263.751V205.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 205.712L283.981 206.055V194.816H285.11V205.712Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 207.135H276.321V194.276H277.5L277.352 207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 194.276V207.135H274.259V194.276H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 199.233C292.859 200.213 292.427 201.128 291.739 201.834V194.816H292.967V199.233Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 201.491C257.37 200.848 257.03 200.064 256.926 199.233V194.816H257.908V201.491Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 204.043L287.86 204.632V194.816H288.989V204.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 207.135H278.138V194.423H279.267V207.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 204.975L285.896 205.466V194.816H287.025V204.975Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 206.251L282.017 206.546V194.816H283.146V206.251Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 206.693H280.053V194.62H281.231V206.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 186.276C285.602 186.276 292.967 190.595 292.967 194.472C292.967 198.35 285.602 202.669 274.946 202.669C264.291 202.669 256.926 198.35 256.926 194.472C256.926 190.595 264.34 186.276 274.946 186.276Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 200.607C285.441 201.108 284.16 201.502 282.852 201.785L268.121 187.061C269.61 186.756 271.12 186.559 272.638 186.472L286.682 200.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 202.669H273.424L260.461 189.712C261.078 189.345 261.718 189.018 262.376 188.73L276.321 202.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 201.933H281.673L283.49 201.393C284.128 201.393 284.718 201 285.307 200.804L286.142 200.264H286.583H287.025L288.744 199.429C289.867 198.801 290.935 198.079 291.936 197.27C291.197 198.392 290.246 199.359 289.137 200.117L288.302 200.656L287.418 201.147H286.976H286.534L285.601 201.54L284.619 201.834H283.686C283.041 202.008 282.385 202.139 281.722 202.227H279.709H277.745H279.758L280.691 201.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 202.227H274.357H275.634H277.008L275.683 202.521H274.995H274.357C273.458 202.595 272.555 202.595 271.656 202.521C270.761 202.429 269.874 202.265 269.005 202.031C268.114 201.84 267.255 201.526 266.451 201.098C267.384 201.098 268.268 201.098 269.152 201.098L271.754 202.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 185.491C277.052 185.498 279.155 185.679 281.231 186.031H292.77V190.448C292.476 194.276 285.159 198.448 274.75 198.448C264.34 198.448 257.024 194.276 256.729 190.448V186.031H268.317C270.506 185.654 272.725 185.474 274.946 185.491Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 193.834C290.717 194.179 290.337 194.476 289.922 194.718V186.031H291.052V193.834Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 185.883V198.055H268.416V186.031L269.545 185.883Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 198.252H270.281V185.785H271.411V198.252Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 195.699L260.461 195.061V186.031H261.59V195.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 198.399H272.295V185.638H273.424V198.399Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 194.521C259.424 194.238 259.047 193.926 258.693 193.589V186.031H259.822V194.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 197.319L264.536 196.975V186.031H265.666V197.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 197.663L266.5 197.319V186.031H267.679L267.63 197.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 196.534L262.572 196.092V186.276H263.751V196.534Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 196.926L283.981 197.27V186.031H285.11V196.926Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 198.35H276.321V185.491H277.5L277.352 198.35Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 185.491V198.399H274.259V185.491H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 190.448C292.859 191.427 292.427 192.343 291.739 193.049V186.031H292.967V190.448Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 192.705C257.37 192.063 257.03 191.279 256.926 190.448V186.031H257.908V192.705Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 195.209C288.63 195.45 288.252 195.663 287.86 195.847V186.031H288.989V195.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 198.153H278.138V185.638H279.267V198.153Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 196.19L285.896 196.681V186.031H287.025V196.19Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 197.319L282.017 197.613V186.031H283.146V197.319Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 197.908H280.053V185.834H281.231V197.908Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 177.687C285.602 177.687 292.967 182.006 292.967 185.883C292.967 189.761 285.602 194.08 274.946 194.08C264.291 194.08 256.926 189.761 256.926 185.883C256.926 182.006 264.34 177.687 274.946 177.687Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 191.822C285.434 192.318 284.155 192.728 282.852 193.049L268.121 178.325C269.61 178.02 271.12 177.823 272.638 177.736L286.682 191.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 193.834H273.424L260.461 180.926C261.078 180.56 261.718 180.232 262.376 179.945L276.321 193.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 193.147H281.673L283.49 192.607C284.128 192.607 284.718 192.215 285.307 192.018L286.24 191.675H286.682H287.124L288.842 190.84C289.965 190.212 291.033 189.49 292.034 188.681C291.295 189.803 290.345 190.77 289.235 191.528L288.4 192.067L287.516 192.509L287.075 192.755H286.633L285.7 193.147L284.718 193.442H283.785C283.139 193.615 282.483 193.746 281.821 193.834H279.807H277.843C278.471 193.657 279.111 193.525 279.758 193.442L280.691 193.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 193.245H274.357H275.634H277.008L275.683 193.54H274.995H274.357C273.458 193.613 272.555 193.613 271.656 193.54C270.761 193.448 269.874 193.284 269.005 193.049C268.114 192.858 267.255 192.544 266.451 192.117C267.384 192.117 268.268 192.117 269.152 192.117L271.754 193.245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 176.706C277.118 176.702 279.286 176.883 281.428 177.245H292.967V181.663C292.672 185.491 285.356 189.663 274.946 189.663C264.536 189.663 257.22 185.491 256.926 181.663V177.245H268.514C270.638 176.881 272.791 176.7 274.946 176.706Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 185.049C290.73 185.407 290.348 185.706 289.922 185.932V177.245H291.052V185.049Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 177.098V189.27H268.416V177.245L269.545 177.098Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 189.466H270.281V177H271.411V189.466Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 186.914L260.461 186.276V177.245H261.59V186.914Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 189.614H272.295V176.853H273.424V189.614Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 185.736C259.424 185.452 259.047 185.141 258.693 184.804V177.245H259.822V185.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 188.386L264.536 188.043V177.245H265.666V188.386Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 188.877L266.5 188.632V177.245H267.679L267.63 188.877Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 187.748L262.572 187.503V177.245H263.751V187.748Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 188.141L283.981 188.485V177.245H285.11V188.141Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 189.564H276.321V176.706H277.5L277.352 189.564Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 176.706V189.613H274.259V176.706H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 181.663C292.859 182.642 292.427 183.558 291.739 184.264V177.245H292.967V181.663Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 183.92C257.37 183.277 257.03 182.494 256.926 181.663V177.245H257.908V183.92Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 186.423C288.63 186.665 288.252 186.878 287.86 187.061V177.245H288.989V186.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 189.368H278.138V176.804H279.267V189.368Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 187.503L285.896 187.945V177.245H287.025V187.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 188.681H282.017V177.245H283.146V188.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 189.123H280.053V177.049H281.231V189.123Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 168.706C285.602 168.706 292.967 173.025 292.967 176.902C292.967 180.779 285.602 185.098 274.946 185.098C264.291 185.098 256.926 180.779 256.926 176.902C256.926 173.025 264.34 168.706 274.946 168.706Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 183.037C285.441 183.538 284.16 183.932 282.852 184.215L268.121 169.491C269.61 169.186 271.12 168.989 272.638 168.902L286.682 183.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 185.049H273.424L260.461 172.141L262.376 171.11L276.321 185.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 184.362H281.673L283.49 183.871C284.128 183.871 284.718 183.478 285.307 183.282L286.142 182.595H286.583H287.025L288.744 181.761C289.867 181.132 290.935 180.41 291.936 179.601C291.209 180.719 290.255 181.672 289.137 182.399C288.88 182.624 288.6 182.821 288.302 182.988L287.418 183.429L286.976 183.675H286.534L285.601 184.067L284.619 184.362H283.686C283.041 184.535 282.385 184.666 281.722 184.755H279.709H277.745L279.66 184.313L280.691 184.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 184.46H274.357H275.634H277.008L275.683 184.755H274.995H274.357C273.458 184.828 272.555 184.828 271.656 184.755C270.761 184.663 269.874 184.498 269.005 184.264C268.165 184.306 267.323 184.24 266.5 184.068C267.433 184.068 268.317 184.068 269.201 184.068L271.754 184.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 167.871C277.118 167.868 279.286 168.048 281.428 168.411H292.967V172.779C292.672 176.607 285.356 180.73 274.946 180.73C264.536 180.73 257.22 176.706 256.926 172.779V168.362H268.514C270.64 168.014 272.792 167.849 274.946 167.871Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 176.264C290.717 176.608 290.337 176.905 289.922 177.147V168.46H291.052V176.264Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 168.313V180.436H268.416V168.46L269.545 168.313Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 180.681H270.281V168.166L271.411 167.871V180.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 178.129L260.657 177.687V168.46H261.59V178.129Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 180.828H272.295V167.871H273.424V180.828Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 176.951C259.424 176.667 259.047 176.355 258.693 176.018V168.46H259.822V176.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 179.601L264.536 179.258V168.46H265.666V179.601Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 180.092L266.5 179.847V168.46H267.679L267.63 180.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 178.963L262.572 178.521V168.46H263.751V178.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 179.356L283.981 179.699V168.46H285.11V179.356Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 180.779H276.321V167.871H277.5L277.352 180.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 167.871V180.779H274.259V167.871H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 172.779C292.859 173.759 292.427 174.674 291.739 175.38V168.46H292.967V172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 175.135C257.37 174.492 257.03 173.708 256.926 172.877V168.46H257.908V175.135Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 177.687C288.63 177.929 288.252 178.142 287.86 178.325V168.509H288.989V177.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 180.583H278.138V167.871H279.267V180.583Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 178.62L285.896 179.061V168.46H287.025V178.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 179.896L282.017 180.19V168.46H283.146V179.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 180.337H280.053V168.264H281.231V180.337Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 159.92C285.602 159.92 292.967 164.239 292.967 168.117C292.967 171.994 285.602 176.313 274.946 176.313C264.291 176.313 256.926 171.994 256.926 168.117C256.926 164.239 264.34 159.92 274.946 159.92Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 174.252C285.441 174.752 284.16 175.146 282.852 175.429L268.121 160.706C269.61 160.4 271.12 160.203 272.638 160.117L286.682 174.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 176.264H273.424L260.461 163.356C261.078 162.99 261.718 162.662 262.376 162.374L276.321 176.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 175.577H281.673L283.49 175.037C284.128 175.037 284.718 174.644 285.307 174.448L286.24 174.104H286.682L287.124 173.859C287.713 173.859 288.253 173.319 288.842 173.074C289.965 172.445 291.033 171.723 292.034 170.914C291.307 172.032 290.354 172.985 289.235 173.712C288.988 173.936 288.706 174.118 288.4 174.251L287.516 174.742L287.075 174.988H286.633L285.7 175.38L284.718 175.675H283.785C283.139 175.848 282.483 175.979 281.821 176.067H279.807H277.843C278.482 176.067 279.12 175.773 279.758 175.626L280.691 175.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 175.675H274.357H275.634H277.008L275.683 175.969H274.995H274.357C272.558 176.069 270.755 175.904 269.005 175.479C268.114 175.288 267.255 174.974 266.451 174.546C267.384 174.546 268.268 174.546 269.152 174.546L271.754 175.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 160.607C277.118 160.604 279.286 160.785 281.428 161.147H292.967V165.564C292.672 169.393 285.356 173.515 274.946 173.515C264.536 173.515 257.22 169.393 256.926 165.564V161.147H268.514C270.638 160.782 272.791 160.602 274.946 160.607Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 168.951C290.704 169.28 290.326 169.576 289.922 169.834V161.147H291.052V168.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 161V173.123H268.416V161.344L269.545 161Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 173.368H270.281V160.853H271.411V173.368Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 170.816L260.461 170.178V161.147H261.59V170.816Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 173.515H272.295V160.706H273.424V173.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 169.638L258.693 168.705V161.147H259.822V169.638Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 172.288L264.536 171.945V161.147H265.666V172.288Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 172.779H266.5V161.147H267.679L267.63 172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 171.65L262.572 171.159V161.344H263.751V171.65Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 172.043L283.981 172.386V161.147H285.11V172.043Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 173.466H276.321V160.607H277.5L277.352 173.466Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 160.607V173.515H274.259V160.607H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 165.564C292.859 166.544 292.427 167.46 291.739 168.166V161.147H292.967V165.564Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 167.871C257.38 167.223 257.04 166.442 256.926 165.613V161.196H257.908V167.871Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 170.325L287.86 170.963V161.147H288.989V170.325Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 173.27H278.138V160.706H279.267V173.27Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 171.307L285.896 171.748V161.147H287.025V171.307Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 172.779H282.017V161.147H283.146V172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 172.779H280.053V160.951H281.231V172.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 152.607C285.602 152.607 292.967 156.926 292.967 160.804C292.967 164.681 285.602 169 274.946 169C264.291 169 256.926 164.681 256.926 160.804C256.926 156.926 264.34 152.607 274.946 152.607Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 166.89C285.45 167.429 284.167 167.84 282.852 168.117L268.121 153.393C269.61 153.087 271.12 152.891 272.638 152.804L286.682 166.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 168.951H273.424L260.461 156.043L262.376 155.012L276.321 168.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 168.264H281.673L283.49 167.773L285.307 167.184L286.24 166.84H286.682H287.124L288.842 166.006C289.975 165.412 291.044 164.705 292.034 163.896C291.307 165.014 290.354 165.967 289.235 166.693L288.4 167.233L287.516 167.724H287.075H286.633L285.7 168.067L284.718 168.411H283.785C283.138 168.569 282.482 168.684 281.821 168.755C281.15 168.803 280.478 168.803 279.807 168.755H277.843L279.758 168.313L280.691 168.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 168.362H274.357H275.634H277.008L275.683 168.656H274.995H274.357C273.459 168.755 272.554 168.755 271.656 168.656C270.762 168.581 269.875 168.433 269.005 168.215C268.16 168.187 267.321 168.072 266.5 167.871C267.433 167.871 268.317 167.871 269.201 167.871L271.754 168.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 151.773C277.12 151.785 279.288 151.982 281.428 152.362H292.967V156.779C292.672 160.607 285.356 164.73 274.946 164.73C264.536 164.73 257.22 160.607 256.926 156.779V152.362H268.514C270.637 151.98 272.789 151.783 274.946 151.773Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 160.166C290.704 160.495 290.326 160.791 289.922 161.049V152.362H291.052V160.166Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 152.215V164.337H268.416V152.558L269.545 152.215Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 164.583H270.281V152.068H271.411V164.583Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 162.031L260.461 161.393V152.362H261.59V162.031Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 164.73H272.295V151.92H273.424V164.73Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 160.853L258.693 159.92V152.362H259.822V160.853Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 163.503L264.536 162.963V152.166H265.666V163.503Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 163.994L266.5 163.748V152.362H267.679L267.63 163.994Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 162.963L262.572 162.472V152.656H263.751V162.963Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 163.258L283.981 163.601V152.362H285.11V163.258Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 164.681H276.321V151.822H277.5L277.352 164.681Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 151.822V164.73H274.259V151.822H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 156.779C292.859 157.759 292.427 158.674 291.739 159.38V152.362H292.967V156.779Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 159.037C257.38 158.388 257.04 157.607 256.926 156.779V152.362H257.908V159.037Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 161.54L287.86 162.178V152.362H288.989V161.54Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 164.485H278.138V151.92H279.267V164.485Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 162.521L286.142 162.963V152.362H287.271L287.025 162.521Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 163.798H282.017V152.362H283.146V163.798Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 164.19H280.053V152.166H281.231V164.19Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 143.822C285.602 143.822 292.967 148.141 292.967 152.018C292.967 155.896 285.602 160.215 274.946 160.215C264.291 160.215 256.926 155.896 256.926 152.018C256.926 148.141 264.34 143.822 274.946 143.822Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 158.055C285.441 158.556 284.16 158.95 282.852 159.233L268.121 144.509C269.61 144.204 271.12 144.007 272.638 143.92L286.682 158.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 160.166H273.424L260.559 147.258L262.474 146.227L276.321 160.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 159.479H281.673L283.49 158.988L285.307 158.399L286.142 158.055H286.583H287.025L288.744 157.221C289.877 156.627 290.946 155.92 291.936 155.11C291.209 156.229 290.255 157.182 289.137 157.908L288.302 158.448L287.418 158.939L286.976 159.184H286.534L285.601 159.528L284.619 159.871H283.686L281.722 160.215C281.052 160.263 280.379 160.263 279.709 160.215H277.745L279.66 159.773L280.691 159.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 159.528L274.357 159.822H275.634H277.008L275.683 160.117H274.995H274.357C273.459 160.215 272.554 160.215 271.656 160.117C270.762 160.041 269.875 159.893 269.005 159.675C268.122 159.459 267.265 159.147 266.451 158.742C267.384 158.742 268.268 158.742 269.152 158.742L271.754 159.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 142.988C277.12 143 279.288 143.197 281.428 143.577H292.967V148.239C292.672 152.067 285.356 156.19 274.946 156.19C264.536 156.19 257.22 152.067 256.926 148.239V143.822H268.514C270.63 143.357 272.782 143.078 274.946 142.988Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 151.38C290.704 151.71 290.326 152.006 289.922 152.264V143.577H291.052V151.38Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 143.331V155.454H268.416V143.675L269.545 143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 155.798H270.281V143.331H271.411V155.798Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 153.147L260.461 152.509V143.577H261.59V153.147Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 155.945H272.295V143.331H273.424V155.945Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 152.067L258.693 151.135V143.577H259.822V152.067Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 154.718L264.536 154.374V143.577H265.666V154.718Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 155.209L266.5 154.963V143.577H267.679L267.63 155.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 154.08L262.572 153.589V143.773H263.751V154.08Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 154.472L283.981 154.816V143.577H285.11V154.472Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 155.896H276.321V143.037H277.5L277.352 155.896Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 143.037V155.945H274.259V143.037H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 148.239C292.859 149.219 292.427 150.135 291.739 150.84V143.577H292.967V148.239Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 150.252C257.38 149.603 257.04 148.822 256.926 147.994V143.577H257.908V150.252Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 152.755C288.629 152.98 288.251 153.177 287.86 153.344V143.528H288.989V152.755Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 155.699H278.138V143.331H279.267V155.699Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 153.736L285.896 154.178V143.577H287.025V153.736Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 155.012L282.017 155.258V143.577H283.146V155.012Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 155.405H280.053V143.331H281.231V155.405Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 135.037C285.602 135.037 292.967 139.356 292.967 143.233C292.967 147.11 285.602 151.429 274.946 151.429C264.291 151.429 256.926 147.11 256.926 143.233C256.926 139.356 264.34 135.037 274.946 135.037Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 149.319C285.443 149.837 284.161 150.248 282.852 150.546L268.121 135.822C269.61 135.517 271.12 135.32 272.638 135.233L286.682 149.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 151.38H273.424L260.559 138.423L262.474 137.393L276.321 151.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 150.693L281.673 150.448L283.49 149.957L285.307 149.368L286.24 149.024H286.682H287.124L288.842 148.19C289.975 147.596 291.044 146.889 292.034 146.08C291.307 147.198 290.354 148.151 289.235 148.877L288.4 149.417L287.516 149.908H287.075H286.633L285.7 150.251L284.718 150.595L283.785 150.84C283.138 150.998 282.482 151.113 281.821 151.184C281.15 151.233 280.478 151.233 279.807 151.184H277.843C278.482 151.184 279.12 150.89 279.758 150.742L280.691 150.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 150.742L274.357 151.037H275.634L277.008 151.282L275.683 151.577H274.995H274.357C273.458 151.651 272.555 151.651 271.656 151.577C270.762 151.501 269.875 151.354 269.005 151.135C268.122 150.92 267.265 150.607 266.451 150.202C267.384 150.202 268.268 150.202 269.152 150.202L271.754 150.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 134.202C277.12 134.215 279.288 134.412 281.428 134.791H292.967V139.209C292.672 143.037 285.356 147.16 274.946 147.16C264.536 147.16 257.22 143.037 256.926 139.209V134.791H268.514C270.637 134.409 272.789 134.212 274.946 134.202Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.052 142.595C290.704 142.925 290.326 143.22 289.922 143.479V134.791H291.052V142.595Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.545 134.644V146.767H268.416V134.988L269.545 134.644Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 147.012H270.281V134.497H271.411V147.012Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59 144.46L260.461 143.822V134.791H261.59V144.46Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.424 147.16H272.295V134.399H273.424V147.16Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 143.331L258.693 142.399V134.791H259.822V143.331Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.666 145.932L264.536 145.589V134.791H265.666V145.932Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63 146.423L266.5 146.178V134.791H267.679L267.63 146.423Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.751 145.294L262.572 144.804V134.988H263.751V145.294Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11 145.687L283.981 146.031V134.791H285.11V145.687Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.352 147.11H276.321V134.252H277.5L277.352 147.11Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.388 134.252V147.16H274.259V134.252H275.388Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.967 139.209C292.859 140.188 292.427 141.104 291.739 141.81V134.791H292.967V139.209Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 141.466C257.38 140.818 257.04 140.037 256.926 139.209V134.791H257.908V141.466Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.989 143.969L287.86 144.558V134.742H288.989V143.969Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.267 146.914H278.138V134.35H279.267V146.914Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.025 144.951L285.896 145.393V134.791H287.025V144.951Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.146 146.227L282.017 146.472V134.791H283.146V146.227Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.231 146.62H280.053V134.595H281.231V146.62Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.946 126.252C285.602 126.252 292.967 130.571 292.967 134.448C292.967 138.325 285.602 142.644 274.946 142.644C264.291 142.644 256.926 138.325 256.926 134.448C256.926 130.571 264.34 126.252 274.946 126.252Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M286.682 140.534C285.443 141.052 284.161 141.462 282.852 141.761L268.121 127.037C269.61 126.732 271.12 126.535 272.638 126.448L286.682 140.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M276.321 142.595H273.424L260.461 129.687C261.077 129.304 261.717 128.96 262.376 128.656L276.321 142.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M280.691 141.908L281.673 141.663L283.49 141.172L285.307 140.583L286.24 140.239H286.682H287.124L288.842 139.405C289.975 138.811 291.044 138.104 292.034 137.294C291.307 138.413 290.354 139.366 289.235 140.092L288.4 140.632L287.516 141.123L287.075 141.368H286.633L285.7 141.712L284.718 142.055L283.785 142.301L281.821 142.644C281.15 142.693 280.478 142.693 279.807 142.644H277.843C278.482 142.644 279.12 142.35 279.758 142.202L280.691 141.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M271.754 141.957L274.357 142.252H275.634L277.008 142.497L275.683 142.791H274.995H274.357C273.458 142.865 272.555 142.865 271.656 142.791C270.765 142.692 269.88 142.545 269.005 142.35C268.129 142.112 267.274 141.8 266.451 141.417C267.351 141.367 268.253 141.367 269.152 141.417L271.754 141.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.377 261.859L396.672 208.018V72.9019L303.377 126.742V261.859Z",
    fill: "#F25C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.276 54.8405L303.377 126.742L396.672 72.9018L273.571 1L180.276 54.8405Z",
    fill: "#F79E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.325 54.9877V190.055L303.426 261.908V126.791L180.325 54.9877ZM296.551 249.982L187.151 186.178V66.816L285.356 124.092L296.65 130.718L296.551 249.982Z",
    fill: "#F04422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8696 244.877L187.151 186.031V66.7668L84.8696 125.564V244.877Z",
    fill: "#F04422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 238.939L84.8696 244.877V125.564L75 119.724V238.939Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 119.724L84.8696 125.564L187.151 66.7669L177.281 60.9264L75 119.724Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.744 156.926C143.592 156.913 143.438 156.931 143.293 156.978C143.147 157.026 143.013 157.102 142.899 157.203C142.784 157.304 142.691 157.428 142.625 157.566C142.559 157.704 142.522 157.853 142.516 158.006C142.459 158.325 142.53 158.653 142.714 158.92C142.898 159.187 143.18 159.37 143.498 159.429C143.651 159.443 143.804 159.425 143.949 159.378C144.095 159.33 144.229 159.253 144.343 159.152C144.458 159.051 144.551 158.928 144.617 158.79C144.683 158.652 144.72 158.502 144.726 158.35C144.76 158.034 144.679 157.717 144.499 157.456C144.319 157.195 144.051 157.007 143.744 156.926Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46 116.141L161.126 112.166C154.596 107.258 144.971 107.258 134.267 113.589C123.903 120.305 115.269 129.37 109.067 140.046C102.865 150.723 99.2681 162.711 98.5693 175.037C98.5693 186.08 102.399 193.883 108.635 197.663L116.148 202.571L120.322 203.159C126.861 203.564 133.355 201.842 138.834 198.252C149.182 191.534 157.802 182.475 163.995 171.808C170.189 161.141 173.781 149.166 174.482 136.853C174.722 130.818 173.185 124.845 170.063 119.675L167.46 116.141Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.927 118.791C131.611 125.484 123.011 134.505 116.819 145.126C110.627 155.748 107.017 167.674 106.278 179.945C106.278 202.521 122.237 211.601 141.927 200.264C152.266 193.541 160.877 184.48 167.061 173.813C173.246 163.146 176.831 151.174 177.526 138.865C177.526 116.288 161.568 107.209 141.927 118.791Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.813 131.159L164.76 125.957C159.457 122.669 152.042 123.012 143.793 127.773C135.371 133.227 128.354 140.589 123.312 149.262C118.27 157.934 115.345 167.673 114.773 177.687C114.424 181.185 114.987 184.715 116.406 187.931C117.826 191.148 120.055 193.942 122.875 196.043L130.584 200.951L131.566 199.429C136.762 199.711 141.914 198.354 146.297 195.552C154.748 190.089 161.786 182.706 166.838 174.006C171.89 165.306 174.812 155.535 175.366 145.491C175.516 140.867 174.413 136.288 172.174 132.239L172.813 131.159Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.866 129.589L168.983 129.294C163.521 127.974 157.76 128.837 152.926 131.699L151.256 132.632L149.636 133.613C143.432 137.805 138.097 143.154 133.923 149.368C133.285 150.251 132.696 151.184 132.106 152.117C126.72 160.326 123.354 169.694 122.286 179.454C122.286 180.534 122.286 181.613 122.286 182.644C122.26 182.856 122.26 183.07 122.286 183.282C122.286 200.607 134.562 207.822 149.636 200.117L151.256 199.233L152.926 198.202C159.718 193.649 165.487 187.732 169.866 180.828C170.456 179.896 171.045 178.963 171.585 177.982C176.795 169.517 179.8 159.882 180.325 149.957V149.172C180.325 148.19 180.325 147.209 180.325 146.227C180.393 142.737 179.44 139.303 177.582 136.347C175.724 133.391 173.042 131.042 169.866 129.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84 134.448C163.312 133.932 160.707 133.927 158.177 134.433C155.647 134.938 153.244 135.945 151.109 137.393C143.895 142.085 137.886 148.408 133.57 155.852C129.254 163.295 126.751 171.65 126.263 180.239C126.023 184.945 127.41 189.589 130.191 193.393C134.611 198.742 142.369 199.528 151.109 194.423C158.338 189.742 164.36 183.423 168.686 175.978C173.012 168.533 175.519 160.172 176.004 151.577C176.152 142.055 172.125 135.969 165.84 134.448Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.773 134.693H165.84C164.24 134.27 162.577 134.137 160.93 134.301C157.449 134.67 154.094 135.81 151.109 137.638C143.895 142.33 137.886 148.654 133.57 156.097C129.254 163.541 126.751 171.895 126.263 180.485C126.108 184.626 127.129 188.727 129.209 192.313C129.553 192.755 129.848 193.245 130.191 193.638C130.919 194.534 131.78 195.312 132.745 195.945C137.311 199.086 143.891 198.89 151.109 194.669C158.338 189.988 164.36 183.668 168.686 176.223C173.012 168.778 175.519 160.418 176.004 151.822C176.152 142.546 172.469 136.607 166.773 134.693Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84 134.448C163.312 133.932 160.707 133.927 158.177 134.433C155.647 134.938 153.244 135.945 151.109 137.393L150.373 137.883C148.151 139.214 146.077 140.777 144.186 142.546C143.736 142.93 143.31 143.339 142.909 143.773C140.162 146.435 137.724 149.399 135.642 152.607C135.007 153.493 134.417 154.411 133.874 155.356C131.286 159.673 129.272 164.309 127.884 169.147C127.884 169.393 127.884 169.638 127.884 169.883C127.272 172.235 126.846 174.631 126.607 177.049C126.607 178.129 126.607 179.209 126.607 180.239C126.485 184.036 127.33 187.803 129.062 191.184C129.472 191.971 129.966 192.711 130.535 193.393C131.702 193.714 132.91 193.863 134.12 193.834C137.302 193.739 140.422 192.934 143.253 191.479L145.168 190.448C147.508 189.042 149.697 187.397 151.698 185.54C161.285 176.794 167.635 165.068 169.719 152.264C169.914 150.635 170.013 148.996 170.014 147.356C170.065 146.555 170.065 145.752 170.014 144.951C169.772 141.096 168.311 137.418 165.84 134.448Z",
    fill: "#F04422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.774 148.239C155.153 147.757 154.431 147.421 153.662 147.258C151.141 146.78 148.532 147.309 146.395 148.73C142.774 151.072 139.758 154.235 137.59 157.961C135.423 161.688 134.167 165.874 133.923 170.178C133.765 172.535 134.462 174.87 135.887 176.755C136.352 177.378 136.957 177.883 137.655 178.227L142.565 181.172L144.333 178.227C145.043 177.969 145.732 177.657 146.395 177.294C150.011 174.94 153.02 171.766 155.179 168.031C157.337 164.296 158.584 160.105 158.818 155.798C158.818 155.258 158.818 154.767 158.818 154.276L160.733 151.086L155.774 148.239Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 150.006L149.636 152.705L150.52 137.982C148.298 139.312 146.224 140.875 144.333 142.644V150.006Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.404 180.141L150.815 151.92C148.004 153.672 145.595 155.997 143.744 158.742C143.454 159.133 143.191 159.543 142.958 159.969V191.528C143.498 191.233 148.998 195.601 149.538 195.307C150.078 195.012 150.913 187.454 151.453 187.11V185.687L151.404 180.141Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.835 169.883C127.223 172.235 126.797 174.631 126.558 177.049L139.128 169.883L134.218 166.497L127.835 169.883Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.719 145.196L159.899 150.693L142.369 160.804C142.204 161.038 142.056 161.284 141.927 161.54C140.456 164.128 139.442 166.951 138.932 169.883L163.483 155.847L169.572 152.411L176.053 148.632L169.817 145.196H169.719Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.123 157.417L141.289 156.779L140.307 155.994L135.789 152.607C135.154 153.493 134.564 154.411 134.021 155.356L137.508 158.006L142.811 160.313C142.811 160.313 143.204 159.626 143.842 158.742H143.547L142.123 157.417Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.971 159.577L143.744 158.791C143.097 159.676 142.522 160.612 142.025 161.589L143.253 162.521L157.984 173.663L160.242 175.38L166.871 178.62L159.162 171.945L144.971 159.577Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.077 134.055L153.564 147.209L157.394 149.908L166.675 134.693H165.742C164.235 134.216 162.657 134 161.077 134.055Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.013 191.184C129.423 191.971 129.917 192.711 130.486 193.393C131.213 194.288 132.074 195.067 133.039 195.699L134.071 193.834L141.632 180.288L136.722 177.491L129.013 191.184Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.636 133.515V200.117L151.256 199.233L152.926 198.202V131.699L151.256 132.632L149.636 133.515Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.283 160.558L152.926 161.933L151.502 162.767L149.734 163.748L148.507 164.485L122.482 179.209C122.482 180.288 122.482 181.368 122.482 182.399C122.456 182.611 122.456 182.825 122.482 183.037L147.034 169.049L150.029 167.331L151.6 166.399L152.582 165.859L153.319 165.466L154.694 164.632L180.718 149.908V149.123C180.718 148.141 180.718 147.16 180.718 146.178L155.283 160.558Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.564 164.092H153.172L151.502 162.963L150.667 162.325L149.636 161.54L133.923 149.368C133.285 150.252 132.696 151.184 132.106 152.117L148.654 164.534L149.292 165.025L149.882 165.466L151.453 166.644L151.944 166.988L153.172 167.92L170.112 180.828C170.701 179.896 171.29 178.963 171.831 177.982L154.546 164.877L153.564 164.092Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.866 129.589L168.983 129.294L152.926 158.055L150.667 162.129L149.734 163.748L149.145 164.828L146.739 169.098L131.321 196.73C131.566 198.448 131.91 200.067 132.303 201.638L149.734 170.423L151.797 166.742L152.288 165.859L153.024 164.583L153.417 163.847L155.381 160.313L171.585 131.307C171.087 130.619 170.545 129.963 169.965 129.344L169.866 129.589Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.095 150.693C159.625 150.447 159.132 150.249 158.622 150.104H158.475C156.377 149.717 154.209 150.063 152.337 151.086L151.355 151.626C151.187 151.689 151.036 151.79 150.913 151.92C148.067 153.661 145.623 155.987 143.744 158.742C143.454 159.133 143.191 159.543 142.958 159.969C142.767 160.231 142.603 160.51 142.467 160.804C142.302 161.038 142.154 161.284 142.025 161.54C140.554 164.128 139.54 166.951 139.03 169.883C138.834 170.952 138.736 172.036 138.735 173.123C138.685 173.743 138.685 174.367 138.735 174.988C138.851 176.774 139.501 178.483 140.601 179.896C140.788 180.148 141.002 180.378 141.239 180.583C141.717 181.016 142.265 181.365 142.86 181.613C144.226 182.058 145.675 182.183 147.097 181.979C148.519 181.774 149.875 181.246 151.06 180.436C153.985 178.773 156.515 176.495 158.475 173.761L159.653 172.043C162.295 168.093 163.79 163.49 163.974 158.742C163.981 157.769 163.882 156.798 163.679 155.847C163.496 154.778 163.079 153.762 162.46 152.872C161.841 151.981 161.033 151.238 160.095 150.693Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.934 154.472C157.58 154.275 157.2 154.127 156.805 154.031C155.206 153.761 153.563 154.038 152.14 154.816L151.404 155.209H151.06C148.92 156.576 147.096 158.383 145.708 160.509C145.467 160.8 145.254 161.112 145.07 161.442L145.065 161.441C144.722 162.029 144.722 162.029 144.379 162.616C143.293 164.577 142.53 166.699 142.123 168.902C141.971 169.695 141.889 170.499 141.878 171.307C141.852 171.781 141.852 172.256 141.878 172.73C142.013 174.024 142.488 175.26 143.253 176.313L143.793 176.804C144.133 177.136 144.533 177.403 144.971 177.589C146.005 177.922 147.101 178.011 148.174 177.85C149.248 177.688 150.269 177.279 151.158 176.656C153.184 175.376 154.936 173.708 156.314 171.748L157.198 170.423C159.171 167.513 160.309 164.118 160.488 160.607C160.486 159.881 160.404 159.156 160.242 158.448C160.158 157.66 159.909 156.9 159.512 156.215C159.114 155.53 158.577 154.936 157.934 154.472Z",
    fill: "#F57D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.934 154.472C157.58 154.275 157.2 154.126 156.805 154.031H156.069C156.231 154.822 156.313 155.628 156.314 156.436C156.074 160.534 154.716 164.489 152.386 167.871L151.355 169.344C149.77 171.557 147.768 173.441 145.462 174.89C144.744 175.304 143.988 175.649 143.204 175.92L143.449 176.264L143.989 176.755C144.33 177.087 144.729 177.354 145.168 177.54C146.205 177.884 147.308 177.984 148.39 177.83C149.472 177.677 150.503 177.275 151.404 176.656C153.44 175.39 155.195 173.72 156.56 171.748L157.443 170.423C159.417 167.513 160.554 164.118 160.733 160.607C160.732 159.881 160.649 159.156 160.488 158.448C160.375 157.64 160.088 156.867 159.647 156.18C159.206 155.494 158.622 154.911 157.934 154.472Z",
    fill: "#AC260C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.802 93.6135C189.734 93.798 189.629 93.9669 189.494 94.1102C189.359 94.2535 189.197 94.3683 189.016 94.4478C188.658 94.6135 188.278 94.7291 187.887 94.7914C187.096 94.9079 186.288 94.7704 185.579 94.3988C185.374 94.3102 185.197 94.1674 185.068 93.9858C184.938 93.8041 184.86 93.5906 184.843 93.3681V103.184C184.87 103.404 184.951 103.613 185.08 103.793C185.209 103.973 185.38 104.118 185.579 104.215H185.923C186.656 104.462 187.449 104.462 188.182 104.215C188.82 104.215 189.802 103.724 189.851 102.89V93.0736C189.851 93.0736 189.802 93.5153 189.802 93.6135Z",
    fill: "#E29F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.115 92.3374C188.493 92.0236 187.796 91.8877 187.101 91.9448V93.3681H184.843C184.86 93.5906 184.938 93.8041 185.068 93.9857C185.197 94.1674 185.374 94.3102 185.579 94.3988C186.131 94.6641 186.735 94.8019 187.347 94.8019C187.959 94.8019 188.563 94.6641 189.115 94.3988C190.097 93.8098 190.097 92.8773 189.115 92.3374Z",
    fill: "#FA7901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.802 162.276C189.734 162.461 189.629 162.629 189.494 162.773C189.359 162.916 189.197 163.031 189.016 163.11C188.658 163.276 188.278 163.392 187.887 163.454C187.096 163.57 186.288 163.433 185.579 163.061C185.374 162.973 185.197 162.83 185.068 162.648C184.938 162.467 184.86 162.253 184.843 162.031V171.847C184.87 172.066 184.951 172.276 185.08 172.456C185.209 172.636 185.38 172.781 185.579 172.877H185.923C186.656 173.124 187.449 173.124 188.182 172.877C188.82 172.877 189.802 172.387 189.851 171.552V161.736C189.858 161.918 189.842 162.099 189.802 162.276Z",
    fill: "#E29F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.115 161C188.493 160.686 187.796 160.55 187.101 160.607V162.031H184.843C184.86 162.253 184.938 162.467 185.068 162.648C185.197 162.83 185.374 162.973 185.579 163.061C186.131 163.327 186.735 163.464 187.347 163.464C187.959 163.464 188.563 163.327 189.115 163.061C190.097 162.472 190.097 161.589 189.115 161Z",
    fill: "#FA7901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.042 344.068L247.449 369L331.021 323.945L286.731 299.307L204.042 344.068Z",
    fill: "url(#paint0_linear_734_19332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.359 280.067V275.65L177.625 235.847C192.355 247.92 195.743 241.834 219.165 255.773C226.187 259.994 240.869 262.939 261.296 279.184C269.546 284.816 278.602 289.167 288.155 292.092L288.646 300.534L209.59 346.227L107.359 280.067Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.155 291.945L209.59 338.031C205.191 336.534 201.05 334.365 197.315 331.601C192.405 327.577 191.079 321.295 181.7 316.387C158.475 304.215 140.356 293.908 133.923 289.196C117.818 277.908 123.808 266.472 123.808 242.62L201.734 198.448C201.734 225.344 195.989 233.687 219.411 247.528C226.433 251.699 238.414 258.767 261.541 270.939C270.92 275.847 272.393 282.129 277.156 286.153C281.919 290.178 284.816 287.528 288.155 291.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.405 313.687L198.199 310.35L197.806 309.614L191.963 312.902L192.405 313.687Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79 293.375L199.716 308.4L200.184 309.149L224.258 294.125L223.79 293.375Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.067 273.787L230.499 289.132L230.967 289.881L255.535 274.536L255.067 273.787Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.059 303.17L188.424 310.116L188.877 310.875L200.512 303.928L200.059 303.17Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68 301.319L214.501 295.184L214.059 294.399L204.238 300.534L204.68 301.319Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.987 292.975L234.289 282.816L233.847 282.08L217.545 292.239L217.987 292.975Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.521 271.033L238.237 279.33L238.705 280.079L251.989 271.782L251.521 271.033Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.844 304.706L237.432 265.638L236.99 264.902L173.353 303.969L173.844 304.706Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.331 300.583L229.919 261.564L229.477 260.828L165.84 299.847L166.331 300.583Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.183 256.911L157.869 295.014L158.329 295.765L220.643 257.662L220.183 256.911Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.437 252.557L150.827 291.581L151.289 292.333L214.899 253.31L214.437 252.557Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.793 288.215L207.381 249.196L206.939 248.46L143.302 287.478L143.793 288.215Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.428 244.355L135.817 283.379L136.279 284.131L199.89 245.108L199.428 244.355Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.466 231.584L126.386 248.811L126.848 249.564L154.929 232.337L154.466 231.584Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 253.221L155.087 235.994L154.595 235.258L126.558 252.485L127 253.221Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.773 238.95L126.692 256.177L127.155 256.93L155.235 239.703L154.773 238.95Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.245 260.632L155.332 243.405L154.841 242.669L126.754 259.896L127.245 260.632Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.625 241.379L141.488 266.616L141.95 267.369L183.087 242.132L182.625 241.379Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.365 311.668L209.355 327.336L209.799 328.1L236.809 312.432L236.365 311.668Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.627 305.295L275.683 288.706L275.192 287.969L248.185 304.558L248.627 305.295Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58 310.202C226.985 310.792 227.238 311.473 227.315 312.184C227.392 312.895 227.291 313.614 227.022 314.276C226.609 314.806 226.047 315.2 225.409 315.41C224.771 315.62 224.084 315.635 223.437 315.454C221.419 315.134 219.443 314.591 217.545 313.834C215.807 313.348 214.152 312.604 212.635 311.626C210.72 310.055 212.979 308.387 214.697 308.73C217.3 309.541 219.639 311.032 221.473 313.049C223.143 314.62 226.384 317.957 223.094 319.528C219.804 321.098 215.581 318.89 212.733 317.417C211.635 316.872 210.503 316.397 209.345 315.994C208.608 315.994 207.528 315.405 207.184 314.62C205.859 312.018 211.407 312.264 212.586 312.558C213.764 312.853 215.63 313.344 215.63 314.718C215.63 316.092 212.782 316.583 211.702 316.779C206.782 317.131 201.837 316.9 196.971 316.092C195.842 316.092 195.842 314.276 196.971 314.374L204.631 315.061C207.23 315.499 209.883 315.516 212.487 315.11C212.487 315.11 213.813 314.767 213.666 315.11C213.519 315.454 212.88 315.11 212.537 314.767C211.493 314.473 210.389 314.473 209.345 314.767C209.05 314.767 208.756 315.209 208.756 314.767C208.756 314.767 209.394 315.11 209.59 315.16L211.309 315.748C213.175 316.436 214.844 317.564 216.71 318.301C217.745 318.743 218.835 319.041 219.951 319.184C220.684 319.334 221.446 319.23 222.112 318.89C222.897 318.35 222.455 317.712 222.112 317.074C220.993 315.676 219.687 314.437 218.233 313.393C217.105 312.405 215.758 311.698 214.304 311.331C213.077 311.331 214.648 311.626 215.09 311.822C216.416 312.411 217.741 312.902 219.116 313.393C220.403 313.843 221.715 314.22 223.045 314.522C223.739 314.795 224.511 314.795 225.205 314.522C226.089 313.933 225.647 312.902 225.205 312.117C224.763 311.331 226.138 310.301 226.727 311.233L226.58 310.202Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.59 332.534L178.116 312.166C178.075 312.139 178.042 312.102 178.019 312.06C177.996 312.017 177.984 311.969 177.984 311.92C177.984 311.872 177.996 311.824 178.019 311.781C178.042 311.738 178.075 311.702 178.116 311.675L212.144 292.043H212.488L244.061 312.362C244.082 312.399 244.093 312.442 244.093 312.485C244.093 312.528 244.082 312.57 244.061 312.607L210.032 332.239H209.689L209.59 332.534ZM212.488 292.632L179 311.969L210.032 331.945L243.471 312.607L212.488 292.632Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.266 312.46L212.144 295.675L188.722 309.319L214.844 326.153L238.266 312.46Z",
    fill: "#F93900"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.529 315.405C200.212 313.147 211.26 307.11 211.26 307.11L287.222 231.675C287.222 231.675 289.088 227.061 288.302 226.178C287.516 225.294 282.459 227.209 282.459 227.209L204.877 300.386C204.877 300.386 198.395 311.331 195.989 315.11C195.999 315.169 196.022 315.224 196.057 315.272C196.091 315.32 196.136 315.36 196.188 315.388C196.24 315.416 196.298 315.433 196.357 315.435C196.416 315.438 196.475 315.428 196.529 315.405Z",
    fill: "#D92F0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.989 314.816C198.395 311.233 204.877 300.092 204.877 300.092C205.433 301.621 206.307 303.015 207.441 304.182C208.575 305.35 209.944 306.264 211.456 306.865C211.456 306.865 200.261 312.902 196.726 315.16C196.68 315.257 196.598 315.333 196.496 315.369C196.395 315.406 196.283 315.401 196.185 315.356C196.088 315.31 196.012 315.228 195.975 315.127C195.939 315.025 195.943 314.914 195.989 314.816Z",
    fill: "#CBD4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.989 314.816C196.627 313.883 197.56 312.362 198.591 310.742C199.089 311.649 199.796 312.423 200.654 313L196.529 315.405C196.451 315.476 196.348 315.514 196.242 315.509C196.136 315.505 196.036 315.458 195.964 315.38C195.893 315.302 195.855 315.199 195.86 315.093C195.864 314.987 195.911 314.888 195.989 314.816Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.508 227.209C283.048 226.963 287.418 225.294 288.302 226.178C289.186 227.061 287.664 230.546 287.32 231.429C285.7 231.675 282.262 229.663 282.508 227.209Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.105 271.577C245.77 271.233 244.52 270.62 243.431 269.776C242.341 268.933 241.436 267.875 240.771 266.669L239.74 267.748C239.74 267.748 240.427 271.38 245.877 273.098L247.105 271.577Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.809 301.662C215.276 301.25 213.846 300.521 212.612 299.524C211.377 298.527 210.365 297.282 209.64 295.871L208.461 297.098C208.461 297.098 209.198 301.221 215.434 303.184L216.809 301.662Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 266.031C258.686 264.222 259.513 262.536 260.706 261.123C261.909 259.666 263.205 258.289 264.586 257C267.384 254.448 270.38 252.092 273.375 249.589C276.37 247.086 279.365 244.681 282.213 242.031C283.669 240.648 285.015 239.155 286.24 237.564C286.86 236.724 287.387 235.819 287.811 234.865C288.341 233.838 288.53 232.669 288.351 231.528C288.334 231.43 288.297 231.337 288.242 231.254C288.188 231.171 288.117 231.1 288.035 231.045C287.952 230.99 287.859 230.952 287.762 230.934C287.664 230.916 287.564 230.917 287.467 230.939C287.294 230.951 287.131 231.029 287.013 231.156C286.894 231.284 286.829 231.452 286.829 231.626C286.513 233.287 285.669 234.802 284.423 235.945C283.149 237.323 281.788 238.619 280.347 239.822L271.411 247.429C268.421 249.976 265.615 252.732 263.014 255.675C261.701 257.187 260.549 258.832 259.577 260.583C258.647 262.243 258.205 264.131 258.3 266.031Z",
    fill: "#232C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.895 265.147L278.138 233.442L277.745 233.049L244.502 264.706L244.895 265.147Z",
    fill: "#EFF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.898 295.92L239.494 269.613L239.101 269.221L211.505 295.528L211.898 295.92Z",
    fill: "#EFF1F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_734_19332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.378 147.504C374.378 147.504 374.391 147.5 374.395 147.496C374.408 147.487 374.426 147.478 374.443 147.469H374.448C374.465 147.461 374.491 147.448 374.513 147.435C374.526 147.426 374.535 147.422 374.548 147.413C374.588 147.391 374.627 147.369 374.675 147.348C374.688 147.343 374.701 147.335 374.714 147.326C384.856 141.976 396.44 138.703 407.749 136.96C410.363 136.556 413.004 136.222 415.64 136C415.64 136 415.648 136 415.653 136L423.862 140.742C423.434 140.781 423.312 141.528 422.887 141.572C422.756 141.585 422.245 141.559 422.109 141.572C421.816 141.602 421.432 142.08 421.139 142.111C412.658 143.036 405.782 144.353 397.704 147.087C393.219 148.604 389.38 149.373 385.179 151.55C385.14 151.572 383.134 151.95 383.094 151.968C383.072 151.981 383.051 151.989 383.033 152.002C382.994 152.024 382.954 152.042 382.919 152.063C382.906 152.072 382.893 152.076 382.88 152.085C382.836 152.111 382.793 152.133 382.753 152.15C382.74 152.159 382.727 152.163 382.718 152.172C382.697 152.185 382.67 152.198 382.653 152.207C382.6 152.237 382.561 152.259 382.535 152.272L374.33 147.53C374.33 147.53 374.36 147.513 374.378 147.504Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.131 218.885C330.672 207.229 331.415 195.486 332.985 184.025C332.989 183.986 332.993 183.951 332.998 183.912C332.998 183.881 333.006 183.855 333.011 183.829C333.015 183.786 333.024 183.747 333.028 183.703C333.028 183.69 333.028 183.681 333.033 183.668C333.037 183.634 333.041 183.599 333.046 183.568C333.055 183.508 333.063 183.451 333.068 183.403L341.273 188.145C341.268 188.193 341.247 188.249 341.251 188.31C342.654 206.942 341.347 224.557 344.206 242.328C345.229 248.678 346.711 255.001 349.338 260.877C352.101 267.058 353.207 273.09 359.008 276.784C359.086 276.832 359.161 276.884 359.239 276.932C359.475 277.08 359.716 277.223 359.961 277.367L351.756 272.625C351.511 272.486 351.275 272.338 351.034 272.19C350.956 272.143 350.881 272.09 350.803 272.043C345.203 268.479 341.142 262.716 338.396 256.779C335.73 251.007 334.195 244.775 333.133 238.512C332.036 232.045 331.389 225.478 331.131 218.881V218.885Z",
    fill: "#FFD471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37 182.03C334.506 181.891 334.637 181.752 334.768 181.613C340.77 175.324 347.026 169.27 353.578 163.55C356.883 160.664 360.267 157.861 363.724 155.162C366.951 152.646 370.264 149.747 373.875 147.808C373.949 147.769 374.019 147.717 374.089 147.674C374.102 147.665 374.111 147.661 374.124 147.652C374.146 147.639 374.168 147.626 374.185 147.613C374.194 147.609 374.198 147.604 374.207 147.6C374.229 147.587 374.251 147.574 374.268 147.565C374.268 147.565 374.273 147.565 374.277 147.561C374.295 147.548 374.312 147.539 374.325 147.53L382.53 152.272C382.53 152.272 382.5 152.289 382.482 152.302C382.482 152.302 382.478 152.302 382.474 152.302C382.456 152.311 382.434 152.324 382.412 152.337C382.408 152.337 382.399 152.346 382.395 152.35C382.373 152.363 382.351 152.376 382.325 152.394C382.316 152.398 382.307 152.407 382.299 152.411C382.272 152.428 382.242 152.446 382.216 152.463C382.207 152.467 382.198 152.476 382.185 152.481C382.146 152.507 382.102 152.533 382.054 152.563C382.045 152.567 382.036 152.576 382.028 152.58C381.988 152.607 381.949 152.628 381.905 152.654C381.888 152.663 381.866 152.672 381.853 152.685C369.788 165.606 354.833 173.933 342.978 186.346C342.847 186.485 342.711 186.624 342.58 186.763C342.147 187.215 341.714 187.671 341.282 188.136L333.076 183.395C333.514 182.93 333.946 182.473 334.375 182.021L334.37 182.03Z",
    fill: "#F5AC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.535 152.272C381.669 152.793 365.22 162.72 341.282 188.145C340.56 193.308 326.9 291.409 382.902 280.092C438.782 227.186 424.606 145.066 423.862 140.742C399.854 142.836 383.4 151.798 382.535 152.272Z",
    fill: "#E29F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.277 188.145C365.22 162.72 381.665 152.793 382.53 152.272C383.396 151.798 399.85 142.841 423.858 140.742C424.605 145.062 438.782 227.182 382.898 280.092C379.846 280.709 377.009 281 374.356 281C328.355 281 340.6 193.026 341.277 188.145ZM342.632 222.614C342.895 232.449 343.939 241.198 345.727 248.613C347.887 257.548 351.13 264.533 355.366 269.37C360.31 275.011 366.522 277.758 374.351 277.758C376.546 277.758 378.889 277.532 381.328 277.088C429.781 230.52 423.486 161.121 421.113 144.275C400.335 146.652 386.076 154.045 384.165 155.075C382.168 156.288 366.71 166.019 344.372 189.601C343.716 194.582 342.235 207.776 342.632 222.61V222.614Z",
    fill: "#FFC233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77 213.883L365.74 203.904C365.714 194.586 372.655 183.199 381.219 178.518C389.778 173.837 396.764 177.61 396.794 186.928L396.825 196.907L399.75 195.307L399.841 225.456L362.938 245.631L362.846 215.482L365.77 213.883ZM379.387 219.724L379.418 229.933L383.313 227.803L383.282 217.594C383.942 216.625 384.362 215.499 384.362 214.487C384.358 212.661 382.994 211.927 381.324 212.84C379.645 213.757 378.29 215.977 378.299 217.803C378.299 218.816 378.727 219.476 379.392 219.72L379.387 219.724ZM370.155 211.484L392.44 199.301L392.41 189.323C392.388 182.638 387.374 179.931 381.232 183.286C375.086 186.645 370.102 194.821 370.124 201.509L370.155 211.488V211.484Z",
    fill: "#FFFFFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_19332",
    x1: 231.932,
    y1: 284.19,
    x2: 280.465,
    y2: 352.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCFD4",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888A8C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_19332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 368,
    fill: "white",
    transform: "translate(57 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_734_19332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 145,
    fill: "white",
    transform: "matrix(-1 0 0 1 426 136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSectionImage);
export default __webpack_public_path__ + "static/media/headSectionImage.4968f140850a8c2744aebf315de5e4ea.svg";
export { ForwardRef as ReactComponent };